// src/pages/ListaReunioes.js
import React, { useState, useEffect } from 'react';
import MemoraAnimacao from '../components/MemoraAnimacao';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { notificar } from '../utils/notify';
import { LABEL_COMPETENCIA } from '../utils/competencias';
import ContestacaoAnalise from '../components/ContestacaoAnalise';
import '../styles/fmp.css';

const ListaReunioes = () => {
  const [reunioes, setReunioes] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [colaboradorSelecionado, setColaboradorSelecionado] = useState('');
  const [nomeColaborador, setNomeColaborador] = useState('');
  const [loading, setLoading] = useState(true);
  const [dataFiltro, setDataFiltro] = useState('');
  const [dataFim, setDataFim] = useState(''); // fim do período (filtro no cliente)
  const [mensagem, setMensagem] = useState('');
  const [analisando, setAnalisando] = useState(false);
  const [reuniaoAnalisandoKey, setReuniaoAnalisandoKey] = useState(null); // qual reunião está sendo analisada
  const [analiseAtual, setAnaliseAtual] = useState(null);
  const [showModalAnalise, setShowModalAnalise] = useState(false);
  const [tiposReuniao, setTiposReuniao] = useState([]);
  const [tipoReuniaoSelecionado, setTipoReuniaoSelecionado] = useState('');
  const [showModalTipo, setShowModalTipo] = useState(false);
  const [reuniaoParaAnalisar, setReuniaoParaAnalisar] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [codigoSalvo, setCodigoSalvo] = useState(null);
  const [apenasPropio, setApenasPropio] = useState(false);
  const [usuarioAdm, setUsuarioAdm] = useState(false); // vem do /reunioes/listar/ (usuario_adm)
  const [reanalisando, setReanalisando] = useState(false); // análise atual é reanálise do adm
  // Análise em lote: seleciona várias reuniões, a IA analisa 2 por vez e cada resultado
  // fica "pronto para revisar" — o salvar continua um a um (cliente/produto/domínio são obrigatórios)
  const [selecionadas, setSelecionadas] = useState({});   // chave -> reunião
  const [lote, setLote] = useState({});                   // chave -> {reuniao, tipo, status, analise, erro, codigo}
  const [showModalLote, setShowModalLote] = useState(false);
  const [tiposLote, setTiposLote] = useState({});         // chave -> tipo escolhido no modal do lote
  const [itemLoteAberto, setItemLoteAberto] = useState(null);
  const [criandoTarefas, setCriandoTarefas] = useState(false);
  const [produtoSelecionado, setProdutoSelecionado] = useState(''); // Setor (nas 1:1)
  // Produtos/serviços da reunião (múltiplos) — reuniões que não são 1:1
  const [produtosSelecionados, setProdutosSelecionados] = useState([]);
  const [novoProdutoTexto, setNovoProdutoTexto] = useState('');
  const [salvandoProduto, setSalvandoProduto] = useState(false);
  // Reuniões de Gestão de Pessoas / 1:1
  const [equipeInterna, setEquipeInterna] = useState([]);
  const [gestorSelecionado, setGestorSelecionado] = useState('');
  const [operadorSelecionado, setOperadorSelecionado] = useState('');

  // Lista de produtos/serviços cadastrados (carregada do backend; com fallback local)
  const PRODUTOS_PADRAO = [
    'BPO Financeiro',
    'Contabilidade',
    'Fiscal',
    'BPO de RH',
    'DP',
    'Caas',
    'BI',
  ];
  const [produtosLista, setProdutosLista] = useState(PRODUTOS_PADRAO);
  const SEP_PRODUTO = ' • '; // separador ao juntar múltiplos produtos no campo 'produto'

  const SETORES = [
    'Contábil',
    'Fiscal',
    'DP / RH',
    'BPO Financeiro',
    'Comercial',
    'CS',
    'Tecnologia',
    'Marketing',
    'Inteligência de Dados',
    'Diretoria / Controladoria',
  ];

  const [filtroLidas, setFiltroLidas] = useState('todas');
  const [calendarConectado, setCalendarConectado] = useState(null); // null = verificando
  // Aviso para operadores não cadastrados no Memor.IA com tarefas na reunião
  const [avisosPendentes, setAvisosPendentes] = useState([]);
  const [showModalAviso, setShowModalAviso] = useState(false);
  const [copiadoIdx, setCopiadoIdx] = useState(null);
  const [numeroDominio, setNumeroDominio] = useState('');
  const [nomeClienteManual, setNomeClienteManual] = useState('');
  const [clientesLista, setClientesLista] = useState([]);
  const [clienteSelecionadoId, setClienteSelecionadoId] = useState('');
  const [buscaEmpresa, setBuscaEmpresa] = useState('');
  const [mostrarSugestoesEmpresa, setMostrarSugestoesEmpresa] = useState(false);
  const [mostrarFormNovo, setMostrarFormNovo] = useState(false);
  const [showModalDoc, setShowModalDoc] = useState(false);
  const [carregandoAnaliseSalva, setCarregandoAnaliseSalva] = useState(null); // codigo em carregamento
  const [modoVisualizacao, setModoVisualizacao] = useState(false); // modal aberto para VER (não salvar/reanalisar)
  const navigate = useNavigate();

  // Remonta o texto "descricao (urgencia) / ..." em lista de pontos_criticos
  const _parsePontos = (texto, tipo) => {
    if (!texto || typeof texto !== 'string') return [];
    return texto.split(' / ').filter(Boolean).map(p => {
      const m = p.match(/^(.*)\s+\(([^)]*)\)\s*$/);
      return m
        ? { tipo, descricao: m[1].trim(), urgencia: m[2].trim() }
        : { tipo, descricao: p.trim(), urgencia: '' };
    });
  };

  const abrirAnaliseSalva = async (codigo) => {
    if (!codigo) return;
    setCarregandoAnaliseSalva(codigo);
    const accessToken = localStorage.getItem('access');
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/reunioes/analise-completa/${encodeURIComponent(codigo)}/`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (res.data.success) {
        const r = res.data.reuniao;
        const ops = res.data.operadores || [];
        // Remodela para o MESMO formato do modal de "Analisar com IA"
        const analise = {
          metadata: {
            tipo_reuniao: r.tipo_reuniao,
            cliente: r.cliente_empresa,
            titulo: r.assunto,
            data_reuniao: r.data_reuniao,
            hora: r.horario,
          },
          classificacao: r.classificacao,
          nota: r.nota,
          interesse_nivel: r.interesse_nivel,
          estagio_venda: r.estagio_venda,
          resumo: r.resumo,
          prospect_info: {
            nome: r.cliente_nome,
            empresa: r.cliente_empresa,
            cargo: r.cliente_cargo,
            orcamento_estimado: r.cliente_orcamento,
            dor_principal: r.cliente_dor_principal,
          },
          objecoes: r.objecoes || [],
          produtos_servicos_interesse: r.produtos_servicos || [],
          pontos_criticos: [
            ..._parsePontos(r.pontos_criticos, 'risco'),
            ..._parsePontos(r.oportunidade, 'oportunidade'),
          ],
          proximos_passos: r.proximos_passos || [],
          anotacoes: r.anotacoes || [],
          sentimento_palavras: {
            positivas: r.palavras_positivas || [],
            negativas: r.palavras_negativas || [],
          },
          analise_operadores: ops.map(o => ({
            nome: o.operador,
            nota: o.nota,
            ponto_forte: o.ponto_forte,
            ponto_melhoria: o.ponto_melhoria,
            objetivo_melhoria: o.objetivo_melhoria,
            competencias: o.competencias || [],
            palavras_positivas: o.palavras_positivas || [],
            palavras_negativas: o.palavras_negativas || [],
          })),
          observacoes: r.observacoes,
        };
        setAnaliseAtual(analise);
        // Gestão/1:1 usa o campo 'produto' como Setor (único); demais tipos, como
        // lista de produtos/serviços (múltiplos, juntados por SEP_PRODUTO).
        if (r.tipo_reuniao === 'gestao') {
          setProdutoSelecionado(r.produto || '');
          setProdutosSelecionados([]);
        } else {
          setProdutoSelecionado('');
          setProdutosSelecionados(
            (r.produto || '').split(SEP_PRODUTO).map(s => s.trim()).filter(Boolean)
          );
        }
        setGestorSelecionado(r.gestor_nome || '');
        setOperadorSelecionado(r.operador_nome || '');
        setCodigoSalvo(codigo);       // já está salva
        setModoVisualizacao(true);    // modo somente leitura
        setShowModalAnalise(true);
      } else {
        setMensagem('' + (res.data.erro || 'Não foi possível abrir a análise.'));
      }
    } catch (err) {
      setMensagem('' + (err.response?.data?.erro || err.message));
    } finally {
      setCarregandoAnaliseSalva(null);
    }
  };

  useEffect(() => { notificar(mensagem); }, [mensagem]);

  // Convite para a Documentação: aparece 5s após entrar na página,
  // enquanto o usuário não tiver visto/dispensado (auth_user.memora_doc_visto)
  useEffect(() => {
    let timer;
    const accessToken = localStorage.getItem('access');
    axios
      .get(`${process.env.REACT_APP_API_BASE}/api/verificar-grupo/`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then((res) => {
        if ((res.data.memora_doc_visto || '').toLowerCase() !== 'sim') {
          timer = setTimeout(() => setShowModalDoc(true), 5000);
        }
      })
      .catch(() => {});
    return () => clearTimeout(timer);
  }, []);

  // Grava no banco que o usuário já viu/dispensou o convite
  const marcarDocVisto = () => {
    const accessToken = localStorage.getItem('access');
    axios
      .post(`${process.env.REACT_APP_API_BASE}/api/reunioes/marcar-doc-visto/`, {}, {
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .catch(() => {});
  };

  useEffect(() => {
    carregarColaboradores();
    carregarTiposReuniao();
    carregarClientesComece();
    carregarEquipeInterna();
    carregarProdutos();
    verificarConexaoCalendar();
  }, []);

  // Produtos/serviços cadastrados (para o multi-select da análise)
  const carregarProdutos = async () => {
    const accessToken = localStorage.getItem('access');
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/reunioes/produtos/`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (response.data.success && (response.data.produtos || []).length) {
        setProdutosLista(response.data.produtos);
      }
    } catch (error) {
      console.error('Erro ao carregar produtos:', error);
    }
  };

  // Adiciona/remove um produto da seleção múltipla
  const toggleProduto = (nome) => {
    setProdutosSelecionados(prev =>
      prev.includes(nome) ? prev.filter(p => p !== nome) : [...prev, nome]
    );
  };

  // Cadastra um novo produto (persiste no backend) e já o seleciona
  const cadastrarNovoProduto = async () => {
    const nome = novoProdutoTexto.trim();
    if (!nome) return;
    setSalvandoProduto(true);
    const accessToken = localStorage.getItem('access');
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/reunioes/produtos/`,
        { nome },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (response.data.success) {
        if ((response.data.produtos || []).length) setProdutosLista(response.data.produtos);
        const nomeFinal = response.data.nome || nome;
        setProdutosSelecionados(prev => prev.includes(nomeFinal) ? prev : [...prev, nomeFinal]);
        setNovoProdutoTexto('');
      } else {
        setMensagem('❌ ' + (response.data.erro || 'Não foi possível cadastrar o produto.'));
      }
    } catch (error) {
      setMensagem('❌ Erro ao cadastrar produto: ' + (error.response?.data?.erro || error.message));
    } finally {
      setSalvandoProduto(false);
    }
  };

  // Equipe interna (auth_user) — alimenta os selects de Gestor/Operador nas reuniões 1:1
  const carregarEquipeInterna = async () => {
    const accessToken = localStorage.getItem('access');
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/reunioes/equipe-interna/`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (response.data.success) setEquipeInterna(response.data.equipe || []);
    } catch (error) {
      console.error('Erro ao carregar equipe interna:', error);
    }
  };

  // Verifica se o usuário já autenticou com o Google (operadores_google_tokens)
  const verificarConexaoCalendar = async () => {
    const accessToken = localStorage.getItem('access');
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/reunioes/verificar-conexao-calendar/`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      setCalendarConectado(!!response.data.conectado);
    } catch (error) {
      console.error('Erro ao verificar conexão do Calendar:', error);
      setCalendarConectado(null); // não exibe o aviso se a verificação falhar
    }
  };

  // Data de N meses atrás (YYYY-MM-DD) para os filtros rápidos de período
  const mesesAtras = (n) => {
    const d = new Date();
    d.setMonth(d.getMonth() - n);
    return d.toISOString().split('T')[0];
  };

  // Aplica um filtro rápido de período (últimos N meses até hoje)
  const aplicarPeriodoRapido = (meses) => {
    setDataFiltro(mesesAtras(meses));
    setDataFim('');
  };

  // Reuniões dentro do período (o "de" já vem filtrado do backend; o "até" é no cliente)
  const reunioesNoPeriodo = dataFim
    ? reunioes.filter(r => (r.data || '') <= dataFim)
    : reunioes;

  useEffect(() => {
    // Padrão: últimos 2 meses
    setDataFiltro(mesesAtras(2));
    setFiltroLidas('nao_lidas');
  }, []);

useEffect(() => {
  if (dataFiltro && colaboradorSelecionado) {
    console.log('Chamando carregarReunioes...');
    console.log('   - dataFiltro:', dataFiltro);
    console.log('   - colaboradorSelecionado:', colaboradorSelecionado);
    carregarReunioes();
  } else {
    console.log('Aguardando filtros:', { dataFiltro, colaboradorSelecionado });
  }
}, [dataFiltro, colaboradorSelecionado]);

  const carregarColaboradores = async () => {
    const accessToken = localStorage.getItem('access');

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/reunioes/colaboradores/`,
        {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      );

      if (response.data.success) {
        setColaboradores(response.data.colaboradores);
        setApenasPropio(response.data.apenas_proprio || false);
        if (response.data.colaboradores.length > 0) {
          setColaboradorSelecionado(response.data.colaboradores[0].id);
        } else {
          // Usuário sem pasta cadastrada: não há reuniões para buscar,
          // encerra o loading para exibir o aviso de autenticação
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    } catch (error) {
      setMensagem('Erro ao carregar colaboradores: ' + error.message);
      setLoading(false);
    }
  };

  const carregarTiposReuniao = async () => {
    const accessToken = localStorage.getItem('access');

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/reunioes/tipos/`,
        {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      );

      if (response.data.success) {
        setTiposReuniao(response.data.tipos);
        if (response.data.tipos.length > 0) {
          setTipoReuniaoSelecionado(response.data.tipos[0].tipo_reuniao);
        }
      }
    } catch (error) {
      console.error('Erro ao carregar tipos de reunião:', error);
    }
  };

  const carregarClientesComece = async () => {
    const accessToken = localStorage.getItem('access');
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/reunioes/clientes-comece/`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (response.data.success) setClientesLista(response.data.clientes);
    } catch (error) {
      console.error('Erro ao carregar clientes:', error);
    }
  };

  const handleSelecionarCliente = (id) => {
    if (!id) {
      setClienteSelecionadoId('');
      setNumeroDominio('');
      return;
    }
    const empresa = clientesLista.find(c => String(c.id) === String(id));
    if (empresa) {
      setClienteSelecionadoId(String(id));
      setNumeroDominio(empresa.numero_dominio != null ? String(empresa.numero_dominio) : '');
      setMostrarFormNovo(false);
      setNomeClienteManual('');
    }
  };

  const normStr = (s) =>
    (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9\s]/g, '').trim();

  const buscarMatchLocal = (nomeIA) => {
    if (!nomeIA || !clientesLista.length) return null;
    const palavras = normStr(nomeIA).split(/\s+/).filter(p => p.length >= 3);
    if (!palavras.length) return null;

    let melhor = null;
    let melhorPontos = 0;

    for (const c of clientesLista) {
      const empNorm = normStr(c.empresa);
      let pontos = 0;
      for (const p of palavras) {
        if (empNorm.includes(p)) pontos++;
      }
      if (pontos > melhorPontos) {
        melhorPontos = pontos;
        melhor = c;
      }
    }
    // Exige pelo menos metade das palavras com 3+ letras coincidindo
    return melhorPontos >= Math.max(1, Math.ceil(palavras.length / 2)) ? melhor : null;
  };

  const mesclarReunioes = (lista) => {
    const mapa = {};
    lista.forEach(reuniao => {
      const chave = `${reuniao.cliente}|${reuniao.titulo}|${reuniao.data}`;
      if (!mapa[chave]) {
        mapa[chave] = { ...reuniao, arquivos: { ...reuniao.arquivos } };
      } else {
        mapa[chave].arquivos = { ...mapa[chave].arquivos, ...reuniao.arquivos };
        if (reuniao.hora < mapa[chave].hora) mapa[chave].hora = reuniao.hora;
        if (reuniao.duracao_min && (!mapa[chave].duracao_min || reuniao.duracao_min > mapa[chave].duracao_min)) {
          mapa[chave].duracao_min = reuniao.duracao_min;
        }
      }
    });
    return Object.values(mapa);
  };

  const carregarReunioes = async () => {
    setLoading(true);
    const accessToken = localStorage.getItem('access');

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/reunioes/listar/`,
        {
          params: { 
            data: dataFiltro,
            colaborador_id: colaboradorSelecionado 
          },
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      );

      if (response.data.success) {
        setReunioes(mesclarReunioes(response.data.reunioes));
        setNomeColaborador(response.data.colaborador);
        setUsuarioAdm(!!response.data.usuario_adm);
        setMensagem('');
      } else {
        setMensagem('Nenhuma reunião encontrada');
      }
    } catch (error) {
      setMensagem('Erro ao carregar reuniões: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Marca/desmarca reunião como interna (a IA valida se todos os participantes são internos)
  const [validandoInterna, setValidandoInterna] = useState(null); // chave titulo|data
  const toggleIgnorarReuniao = async (reuniao) => {
    const chave = `${reuniao.titulo}|${reuniao.data}`;
    setValidandoInterna(chave);
    if (!reuniao.ignorada) {
      setMensagem('Verificando com a Memor.IA se todos os participantes são internos...');
    }
    const accessToken = localStorage.getItem('access');
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/reunioes/ignorar/`,
        {
          titulo: reuniao.titulo,
          data: reuniao.data,
          cliente: reuniao.cliente,
          file_id: reuniao.arquivos?.anotacoes?.id || null,
        },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (response.data.success) {
        setReunioes(prev => prev.map(r =>
          r.titulo === reuniao.titulo && r.data === reuniao.data
            ? { ...r, ignorada: response.data.ignorada }
            : r
        ));
        setMensagem(response.data.ignorada
          ? `"${reuniao.titulo}" marcada como reunião interna — não será analisada.`
          : `"${reuniao.titulo}" voltou para a lista de reuniões.`);
      }
    } catch (error) {
      setMensagem('' + (error.response?.data?.erro || error.message));
    } finally {
      setValidandoInterna(null);
    }
  };

  const abrirModalTipo = (reuniao) => {
    if (!reuniao.arquivos || !reuniao.arquivos.anotacoes) {
      setMensagem('Esta reunião não possui arquivo de transcrição para analisar');
      return;
    }
    
    setReuniaoParaAnalisar(reuniao);
    setShowModalTipo(true);
  };

  const confirmarAnalise = () => {
    if (!tipoReuniaoSelecionado) {
      setMensagem('Selecione o tipo de reunião');
      return;
    }
    
    setShowModalTipo(false);
    analisarReuniao(reuniaoParaAnalisar, tipoReuniaoSelecionado);
  };

  // Auto-preenche Setor / Operador / Gestor de uma reunião 1:1 com base no que a IA
  // identificou (analise_operadores). O usuário pode ajustar os selects depois.
  const preencherGestao1a1 = (analise) => {
    setGestorSelecionado('');
    setOperadorSelecionado('');
    setProdutoSelecionado('');

    const ops = analise?.analise_operadores || [];
    if (ops.length === 0) return;

    // Casa cada participante identificado pela IA com um membro da equipe (auth_user)
    const casar = (op) => {
      let m = null;
      if (op.id_usuario != null) {
        m = equipeInterna.find(x => String(x.id) === String(op.id_usuario));
      }
      if (!m && op.nome) {
        const nn = op.nome.trim().toLowerCase();
        m = equipeInterna.find(x => (x.nome || '').trim().toLowerCase() === nn)
          || equipeInterna.find(x => (x.nome || '').toLowerCase().includes(nn.split(' ')[0]));
      }
      return { membro: m, nomeIA: (op.nome || '').trim() };
    };

    const casados = ops.map(casar);
    const gestorMatch = casados.find(x => x.membro && x.membro.is_gestor);
    // Colaborador = participante que NÃO é o gestor (mesmo que não esteja cadastrado)
    const operadorMatch = casados.find(x => !gestorMatch || (x.nomeIA && x.nomeIA !== gestorMatch.nomeIA));

    const gestor = gestorMatch?.membro || null;
    if (gestor) setGestorSelecionado(gestor.nome);

    // Operador: usa o nome do membro se cadastrado; senão o nome que a IA identificou
    let operadorNome = '';
    if (operadorMatch) {
      operadorNome = operadorMatch.membro ? operadorMatch.membro.nome : operadorMatch.nomeIA;
      setOperadorSelecionado(operadorNome);
    }

    // Setor: do colaborador (se cadastrado) ou do setor que o gestor gerencia
    const setorRef = operadorMatch?.membro?.setor || gestor?.gestor_setor || null;
    if (setorRef) {
      const setorMatch = SETORES.find(s => s.toLowerCase() === setorRef.toLowerCase());
      setProdutoSelecionado(setorMatch || setorRef);
    }
  };

  const analisarReuniao = async (reuniao, tipoReuniao) => {
    setAnalisando(true);
    setReuniaoAnalisandoKey(`${reuniao.titulo}|${reuniao.data}`);
    // Zera a seleção de produtos/serviços a cada nova análise
    setProdutosSelecionados([]);
    setNovoProdutoTexto('');
    setMensagem('Analisando reunião com a Memor.IA... Isso pode levar alguns segundos.');

    const accessToken = localStorage.getItem('access');

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/reunioes/analisar/`,
        {
          file_id: reuniao.arquivos.anotacoes.id,
          cliente: reuniao.cliente,
          titulo: reuniao.titulo,
          data: reuniao.data,
          hora: reuniao.hora,
          tipo_reuniao: tipoReuniao
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      );

      if (response.data.success) {
        setItemLoteAberto(null);
        abrirResultadoAnalise(response.data.analise, tipoReuniao);
        setMensagem('Análise concluída com sucesso!');
      }
    } catch (error) {
      const errorMsg = error.response?.data?.erro || error.message;
      setMensagem(`Erro ao analisar reunião: ${errorMsg}`);
    } finally {
      setAnalisando(false);
      setReuniaoAnalisandoKey(null);
    }
  };

  // Abre o modal com uma análise pronta e pré-preenche empresa/domínio (ou, no 1:1,
  // gestor/operador/setor). Usado pela análise individual e pela revisão do lote.
  const abrirResultadoAnalise = (analise, tipoReuniao) => {
        setProdutosSelecionados([]);
        setNovoProdutoTexto('');
        setAnaliseAtual(analise);
        setCodigoSalvo(null);
        setModoVisualizacao(false);
        setShowModalAnalise(true);

        // Gestão de Pessoas / 1:1 é reunião interna — a empresa é sempre a Comece
        if (tipoReuniao === 'gestao') {
          const matchComece = buscarMatchLocal('Comece');
          setNumeroDominio(matchComece?.numero_dominio != null ? String(matchComece.numero_dominio) : '');
          if (matchComece?.id) {
            setClienteSelecionadoId(String(matchComece.id));
            setBuscaEmpresa(matchComece.empresa || 'Comece');
            setNomeClienteManual('');
            setMostrarFormNovo(false);
          } else {
            setClienteSelecionadoId('');
            setBuscaEmpresa('Comece');
            setNomeClienteManual('Comece');
            setMostrarFormNovo(true);
          }
          // Tenta identificar Operador, Setor e Gestor a partir da análise da IA
          preencherGestao1a1(analise);
          return;
        }

        // Prefere o nome da empresa identificado dentro da conversa pela IA
        const nomeEmpresaIA = analise?.prospect_info?.empresa
          || analise?.metadata?.cliente_match?.empresa
          || '';

        // 1. Tenta o match que o backend fez (baseado na pasta do Drive)
        const backendMatch = analise?.metadata?.cliente_match;

        // 2. Tenta fuzzy match local usando o nome que a IA extraiu da conversa
        const localMatch = nomeEmpresaIA ? buscarMatchLocal(nomeEmpresaIA) : null;

        // Prioriza o match local (nome real da empresa) sobre o match do backend (nome da pasta)
        const match = localMatch || (backendMatch?.id ? backendMatch : null);

        if (match?.id) {
          setNumeroDominio(match.numero_dominio != null ? String(match.numero_dominio) : '');
          setClienteSelecionadoId(String(match.id));
          setBuscaEmpresa(match.empresa || '');
          setNomeClienteManual('');
          setMostrarFormNovo(false);
        } else {
          // Nenhuma empresa encontrada — deixa o campo de busca preenchido com o nome
          // identificado pela IA para o usuário procurar na lista; só abre o cadastro
          // se ele clicar no botão "+".
          setNumeroDominio('');
          setClienteSelecionadoId('');
          setBuscaEmpresa(nomeEmpresaIA);
          setNomeClienteManual('');
          setMostrarFormNovo(false);
        }
  };

  // ── Análise em lote ──────────────────────────────────────────────
  const LIMITE_PARALELO_LOTE = 2;   // análises simultâneas (Gemini + tempo do servidor)
  const chaveReuniao = (r) => `${r.titulo}|${r.data}`;
  const podeAnalisarEmLote = (r) => !r.ignorada && !r.lida && !!r.arquivos?.anotacoes
    && !(r.sou_responsavel === false && !usuarioAdm)
    && !['na_fila', 'analisando', 'pronta', 'salva'].includes(lote[chaveReuniao(r)]?.status);

  const alternarSelecao = (r) => setSelecionadas(sel => {
    const n = { ...sel };
    const k = chaveReuniao(r);
    if (n[k]) delete n[k]; else n[k] = r;
    return n;
  });

  const abrirModalLote = () => {
    const padrao = tipoReuniaoSelecionado || tiposReuniao[0]?.tipo_reuniao || '';
    const t = {};
    Object.keys(selecionadas).forEach(k => { t[k] = tiposLote[k] || padrao; });
    setTiposLote(t);
    setShowModalLote(true);
  };

  const iniciarLote = async () => {
    const itens = Object.entries(selecionadas).map(([k, r]) => ({ k, r, tipo: tiposLote[k] }));
    if (!itens.length) return;
    if (itens.some(i => !i.tipo)) { setMensagem('Escolha o tipo de cada reunião.'); return; }
    setShowModalLote(false);
    setSelecionadas({});
    setLote(l => {
      const n = { ...l };
      itens.forEach(i => { n[i.k] = { reuniao: i.r, tipo: i.tipo, status: 'na_fila' }; });
      return n;
    });
    setMensagem(`Analisando ${itens.length} reunião(ões) com a Memor.IA. Revise e salve cada uma assim que ficar pronta.`);

    const accessToken = localStorage.getItem('access');
    let proxima = 0;
    const trabalhador = async () => {
      while (proxima < itens.length) {
        const it = itens[proxima++];
        setLote(l => ({ ...l, [it.k]: { ...l[it.k], status: 'analisando' } }));
        try {
          const res = await axios.post(
            `${process.env.REACT_APP_API_BASE}/api/reunioes/analisar/`,
            {
              file_id: it.r.arquivos.anotacoes.id,
              cliente: it.r.cliente,
              titulo: it.r.titulo,
              data: it.r.data,
              hora: it.r.hora,
              tipo_reuniao: it.tipo,
            },
            { headers: { Authorization: `Bearer ${accessToken}` } }
          );
          if (!res.data.success) throw new Error(res.data.erro || 'Falha na análise');
          setLote(l => ({ ...l, [it.k]: { ...l[it.k], status: 'pronta', analise: res.data.analise } }));
        } catch (e) {
          setLote(l => ({ ...l, [it.k]: { ...l[it.k], status: 'erro', erro: e.response?.data?.erro || e.message } }));
        }
      }
    };
    await Promise.all(Array.from({ length: Math.min(LIMITE_PARALELO_LOTE, itens.length) }, trabalhador));
    setMensagem('Análises do lote concluídas. Revise e salve as que estão prontas.');
  };

  const revisarItemLote = (k) => {
    const it = lote[k];
    if (!it?.analise) return;
    setReanalisando(false);
    setItemLoteAberto(k);
    abrirResultadoAnalise(it.analise, it.tipo);
  };

  const descartarItemLote = (k) => setLote(l => { const n = { ...l }; delete n[k]; return n; });

  const salvarAnalise = async () => {
    if (!analiseAtual) return;

    // Trava: exige empresa (exceto 1:1, que é sempre Comece), domínio e produto/setor
    const tipoRn = analiseAtual.metadata?.tipo_reuniao;
    const semEmpresa = tipoRn !== 'gestao'
      && !clienteSelecionadoId
      && !(mostrarFormNovo && nomeClienteManual.trim());
    const semDominio = tipoRn !== 'gestao' && !String(numeroDominio || '').trim();
    const semProduto = tipoRn === 'gestao' ? !produtoSelecionado : produtosSelecionados.length === 0;
    if (semEmpresa || semDominio || semProduto) {
      const faltas = [
        semEmpresa && 'a empresa (cliente)',
        semDominio && 'o nº de domínio',
        semProduto && (tipoRn === 'gestao' ? 'o setor' : 'o produto/serviço'),
      ].filter(Boolean);
      const listaFaltas = faltas.length > 1
        ? faltas.slice(0, -1).join(', ') + ' e ' + faltas[faltas.length - 1]
        : faltas[0];
      setMensagem(`Preencha ${listaFaltas} antes de salvar.`);
      return;
    }

    // 1:1 grava o Setor no campo 'produto'; demais tipos gravam os produtos juntados
    const produtoParaSalvar = tipoRn === 'gestao'
      ? (produtoSelecionado || null)
      : (produtosSelecionados.join(SEP_PRODUTO) || null);

    setSalvando(true);
    const accessToken = localStorage.getItem('access');

    try {
      const empresaSelecionadaNome = clienteSelecionadoId
        ? (clientesLista.find(c => String(c.id) === String(clienteSelecionadoId))?.empresa || null)
        : (mostrarFormNovo && nomeClienteManual ? nomeClienteManual : null);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/reunioes/salvar/`,
        {
          analise: analiseAtual,
          numero_dominio: numeroDominio ? parseInt(numeroDominio) : null,
          nome_cliente_manual: mostrarFormNovo && nomeClienteManual ? nomeClienteManual : null,
          empresa_selecionada_nome: empresaSelecionadaNome,
          produto: produtoParaSalvar,
          gestor_nome: gestorSelecionado || null,
          operador_nome: operadorSelecionado || null,
          reanalisar: reanalisando,
        },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      if (response.data.success) {
        setCodigoSalvo(response.data.codigo_reuniao);
        if (itemLoteAberto) {
          const k = itemLoteAberto;
          const cod = response.data.codigo_reuniao;
          setLote(l => (l[k] ? { ...l, [k]: { ...l[k], status: 'salva', codigo: cod } } : l));
          setReunioes(rs => rs.map(r => (chaveReuniao(r) === k ? { ...r, lida: true, codigo_reuniao: cod } : r)));
          setItemLoteAberto(null);
        }
        const empMsg = response.data.empresa_resultado === 'cadastrada'
          ? ` | Empresa "${nomeClienteManual}" cadastrada na tabela`
          : response.data.empresa_resultado === 'existente'
          ? ` | Empresa já existia na tabela`
          : response.data.empresa_resultado?.startsWith('erro')
          ? ` | Erro ao cadastrar empresa: ${response.data.empresa_resultado}`
          : '';
        setMensagem(`Análise salva com sucesso! Código: ${response.data.codigo_reuniao}${empMsg}`);

        if (response.data.empresa_resultado === 'cadastrada') {
          // Recarrega lista para que a empresa recém-cadastrada apareça nas próximas análises
          const accessToken = localStorage.getItem('access');
          try {
            const resClientes = await axios.get(
              `${process.env.REACT_APP_API_BASE}/api/reunioes/clientes-comece/`,
              { headers: { Authorization: `Bearer ${accessToken}` } }
            );
            if (resClientes.data.success) {
              setClientesLista(resClientes.data.clientes);
              const novaEmpresa = resClientes.data.clientes.find(
                c => c.empresa.toLowerCase() === nomeClienteManual.toLowerCase()
              );
              if (novaEmpresa) {
                setClienteSelecionadoId(String(novaEmpresa.id));
                setMostrarFormNovo(false);
              }
            }
          } catch (_) {}
        }
      }
    } catch (error) {
      const errorMsg = error.response?.data?.erro || error.message;
      // 409 = reunião já analisada (por outro participante) — mostra a mensagem do servidor
      setMensagem(error.response?.status === 409 ? errorMsg : `Erro ao salvar análise: ${errorMsg}`);
    } finally {
      setSalvando(false);
    }
  };
const criarTarefasCalendario = async () => {
  if (!analiseAtual) return;

  setCriandoTarefas(true);
  const accessToken = localStorage.getItem('access');

  try {
    let codigo = codigoSalvo;

    if (!codigo) {
      setMensagem('Salvando análise antes de criar tarefas...');
      const empresaSelecionadaNome = clienteSelecionadoId
        ? (clientesLista.find(c => String(c.id) === String(clienteSelecionadoId))?.empresa || null)
        : (mostrarFormNovo && nomeClienteManual ? nomeClienteManual : null);
      const _tipoRn = analiseAtual.metadata?.tipo_reuniao;
      const _produtoSalvar = _tipoRn === 'gestao'
        ? (produtoSelecionado || null)
        : (produtosSelecionados.join(SEP_PRODUTO) || null);

      const resSalvar = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/reunioes/salvar/`,
        {
          analise: analiseAtual,
          numero_dominio: numeroDominio ? parseInt(numeroDominio) : null,
          nome_cliente_manual: mostrarFormNovo && nomeClienteManual ? nomeClienteManual : null,
          empresa_selecionada_nome: empresaSelecionadaNome,
          produto: _produtoSalvar,
          gestor_nome: gestorSelecionado || null,
          operador_nome: operadorSelecionado || null,
          reanalisar: reanalisando,
        },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (!resSalvar.data.success) {
        setMensagem('Erro ao salvar análise antes de criar tarefas.');
        return;
      }
      codigo = resSalvar.data.codigo_reuniao;
      setCodigoSalvo(codigo);
    }

    setMensagem('Criando tarefas no Google Calendar...');

    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE}/api/reunioes/criar-tarefas-calendario/`,
      {
        analise: analiseAtual,
        codigo_reuniao: codigo
      },
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );

    if (response.data.success) {
      setMensagem(`${response.data.total} tarefas criadas no Google Calendar!`);

      // Responsáveis não cadastrados no Memor.IA → mostra aviso na tela
      const pendentes = (response.data.responsaveis_sem_autorizacao || []).map(r => ({
        nome: r.nome,
        tarefas: coletarTarefasDe(r.nome),
      }));
      if (pendentes.length > 0) {
        setAvisosPendentes(pendentes);
        setShowModalAviso(true);
      }
    }
  } catch (error) {
    setMensagem(error.response?.status === 409
      ? error.response.data.erro
      : `Erro ao criar tarefas: ${error.response?.data?.erro || error.message}`);
  } finally {
    setCriandoTarefas(false);
  }
};

// Junta as tarefas da análise atual atribuídas a um responsável
const coletarTarefasDe = (nomeResp) => {
  const alvo = normStr(nomeResp);
  if (!alvo) return [];
  const lista = [];
  (analiseAtual?.action_items || []).forEach(it => {
    const r = normStr(it.responsavel || '');
    if (r && (r.includes(alvo) || alvo.includes(r))) {
      lista.push({ tarefa: it.tarefa || it.acao, prazo: it.prazo });
    }
  });
  (analiseAtual?.proximos_passos || []).forEach(p => {
    if (typeof p === 'object' && p) {
      const r = normStr(p.responsavel || '');
      if (r && (r.includes(alvo) || alvo.includes(r))) {
        lista.push({ tarefa: p.acao || p.tarefa, prazo: p.prazo });
      }
    }
  });
  return lista;
};

// Monta a mensagem pronta para colar no chat e copia para a área de transferência
const copiarAvisoTarefas = (idx) => {
  const pessoa = avisosPendentes[idx];
  const titulo = analiseAtual?.metadata?.titulo || '';
  const codigo = codigoSalvo ? ` (${codigoSalvo})` : '';
  const primeiroNome = (pessoa.nome || '').split(' ')[0];

  const linhas = pessoa.tarefas.length > 0
    ? pessoa.tarefas.map(t => `• ${t.tarefa}${t.prazo ? ` — prazo: ${t.prazo}` : ''}`).join('\n')
    : '• Consulte a análise da reunião para ver os detalhes.';

  const mensagemChat =
`Oi ${primeiroNome}! A reunião "${titulo}"${codigo} foi analisada no Memor.IA e você tem tarefa(s) sob sua responsabilidade:

${linhas}

Qualquer dúvida me chama! `;

  navigator.clipboard.writeText(mensagemChat).then(() => {
    setCopiadoIdx(idx);
    setTimeout(() => setCopiadoIdx(null), 2500);
  });
};
  const formatarTamanho = (bytes) => {
    if (!bytes || bytes === '0') return '-';
    const numBytes = parseInt(bytes);
    const mb = numBytes / (1024 * 1024);
    return mb < 1 ? `${(numBytes / 1024).toFixed(0)} KB` : `${mb.toFixed(1)} MB`;
  };

  const formatarData = (data) => {
    if (!data || typeof data !== 'string') return '-';
    const partes = data.split('-');
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  };

  const formatarDataBR = (dataISO) => {
    if (!dataISO) return '';
    const partes = dataISO.split('-');
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  };

  // Encurta textos longos (a IA às vezes devolve a frase inteira como "palavra")
  const encurtar = (texto, max = 60) => {
    const t = String(texto || '');
    return t.length > max ? t.slice(0, max).trim() + '…' : t;
  };

  const getBadgeClassificacao = (classificacao) => {
    switch(classificacao) {
      case 'muito_boa': return 'bg-success';
      case 'boa': return 'bg-primary';
      case 'critica': return 'bg-danger';
      default: return 'bg-secondary';
    }
  };

  const passaFiltroAba = (r) => {
    if (filtroLidas === 'ignoradas') return r.ignorada;
    if (r.ignorada) return false;
    if (filtroLidas === 'todas') return true;
    return filtroLidas === 'lidas' ? r.lida : !r.lida;
  };

  const renderBarraLote = () => {
    const elegiveis = reunioesNoPeriodo.filter(passaFiltroAba).filter(podeAnalisarEmLote);
    const nSel = Object.keys(selecionadas).length;
    const itensLote = Object.entries(lote);
    if (!elegiveis.length && !nSel && !itensLote.length) return null;
    const conta = (st) => itensLote.filter(([, it]) => it.status === st).length;
    const emAndamento = conta('na_fila') + conta('analisando');
    const prontas = itensLote.filter(([, it]) => it.status === 'pronta');
    const erros = itensLote.filter(([, it]) => it.status === 'erro');
    return (
      <div className="row mb-3">
        <div className="col-12">
          <div className="bg-white border rounded-3 shadow-sm px-3 py-2">
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <span className="fw-semibold me-1" style={{ color: '#495057', fontSize: '0.85rem' }}>
                <i className="fas fa-layer-group me-1"></i>Análise em lote:
              </span>
              {elegiveis.length > 0 && (
                <button type="button" className="btn btn-sm btn-outline-secondary" style={{ borderRadius: 999 }}
                  onClick={() => setSelecionadas(sel => {
                    const n = { ...sel };
                    elegiveis.forEach(r => { n[chaveReuniao(r)] = r; });
                    return n;
                  })}>
                  <i className="fas fa-check-double me-1"></i>Selecionar pendentes ({elegiveis.length})
                </button>
              )}
              {nSel > 0 && (
                <button type="button" className="btn btn-sm btn-link text-muted" onClick={() => setSelecionadas({})}>
                  Limpar seleção
                </button>
              )}
              <button type="button" className="btn btn-sm ms-auto" onClick={abrirModalLote} disabled={!nSel}
                style={{ borderRadius: 999, fontWeight: 600, color: '#fff', border: 'none',
                  background: nSel ? 'linear-gradient(135deg, #d610b5 0%, #a30c8a 100%)' : '#adb5bd' }}>
                <i className="fas fa-brain me-1"></i>Analisar selecionadas ({nSel})
              </button>
            </div>
            {itensLote.length > 0 && (
              <div className="d-flex align-items-center gap-3 flex-wrap mt-2 pt-2 border-top" style={{ fontSize: '0.85rem' }}>
                {emAndamento > 0 && (
                  <span style={{ color: '#495057' }}><span className="spinner-border spinner-border-sm me-1"></span>{emAndamento} analisando</span>
                )}
                <span style={{ color: '#b54708', fontWeight: 600 }}><i className="fas fa-clipboard-check me-1"></i>{prontas.length} pronta(s) para revisar</span>
                <span style={{ color: '#067647' }}><i className="fas fa-check-circle me-1"></i>{conta('salva')} salva(s)</span>
                {erros.length > 0 && <span style={{ color: '#b42318' }}><i className="fas fa-triangle-exclamation me-1"></i>{erros.length} com erro</span>}
                {prontas.length > 0 && (
                  <button type="button" className="btn btn-sm btn-warning ms-auto" style={{ borderRadius: 999, fontWeight: 600 }}
                    onClick={() => revisarItemLote(prontas[0][0])}>
                    <i className="fas fa-pen-to-square me-1"></i>Revisar próxima
                  </button>
                )}
                {!emAndamento && !prontas.length && (
                  <button type="button" className="btn btn-sm btn-link text-muted ms-auto"
                    onClick={() => setLote(l => Object.fromEntries(Object.entries(l).filter(([, it]) => it.status === 'erro')))}>
                    Limpar concluídas
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderModalLote = () => {
    if (!showModalLote) return null;
    const itens = Object.entries(selecionadas);
    const aplicarATodas = (tipo) => setTiposLote(() => {
      const t = {};
      itens.forEach(([k]) => { t[k] = tipo; });
      return t;
    });
    return (
      <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        onClick={() => setShowModalLote(false)}>
        <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content">
            <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
              <div>
                <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                  <i className="fas fa-layer-group me-2"></i>Analisar {itens.length} reunião(ões)
                </h5>
                <div style={{ color: '#6c757d', fontSize: '0.85rem' }}>
                  Escolha o tipo de cada reunião. A Memor.IA analisa {LIMITE_PARALELO_LOTE} por vez; depois você revisa e salva uma a uma.
                </div>
              </div>
              <button type="button" className="btn-close" onClick={() => setShowModalLote(false)}></button>
            </div>
            <div className="modal-body">
              <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                <span className="text-muted" style={{ fontSize: '0.85rem' }}>Aplicar a todas:</span>
                <select className="form-select form-select-sm" style={{ maxWidth: 280 }} defaultValue=""
                  onChange={(e) => e.target.value && aplicarATodas(e.target.value)}>
                  <option value="">Escolha um tipo…</option>
                  {tiposReuniao.map(t => <option key={t.id} value={t.tipo_reuniao}>{t.nome_exibicao}</option>)}
                </select>
              </div>
              <table className="table table-sm align-middle mb-0" style={{ fontSize: '0.88rem' }}>
                <thead><tr className="text-muted"><th>Reunião</th><th style={{ width: 260 }}>Tipo</th><th></th></tr></thead>
                <tbody>
                  {itens.map(([k, r]) => (
                    <tr key={k}>
                      <td>
                        <div className="fw-semibold" style={{ color: '#212529' }}>{r.titulo}</div>
                        <div className="text-muted" style={{ fontSize: '0.78rem' }}>{formatarData(r.data)} às {r.hora} · {r.cliente}</div>
                      </td>
                      <td>
                        <select className="form-select form-select-sm" value={tiposLote[k] || ''}
                          onChange={(e) => setTiposLote(t => ({ ...t, [k]: e.target.value }))}>
                          <option value="">Escolha…</option>
                          {tiposReuniao.map(t => <option key={t.id} value={t.tipo_reuniao}>{t.nome_exibicao}</option>)}
                        </select>
                      </td>
                      <td className="text-end">
                        <button type="button" className="btn btn-sm btn-link text-muted" title="Tirar do lote"
                          onClick={() => alternarSelecao(r)}><i className="fas fa-times"></i></button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowModalLote(false)}>
                <i className="fas fa-times me-2"></i>Cancelar
              </button>
              <button className="btn btn-primary" onClick={iniciarLote}
                disabled={!itens.length || itens.some(([k]) => !tiposLote[k])}
                style={{ background: 'linear-gradient(135deg, #d610b5 0%, #a30c8a 100%)', border: 'none' }}>
                <i className="fas fa-brain me-2"></i>Analisar {itens.length} com Memor.IA
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderModalTipo = () => {
    if (!showModalTipo) return null;

    return (
      <div 
        className="modal fade show d-block" 
        style={{backgroundColor: 'rgba(0,0,0,0.5)'}}
        onClick={() => setShowModalTipo(false)}
      >
        <div 
          className="modal-dialog modal-dialog-centered"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content">
            <div className="modal-header" style={{backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef'}}>
              <h5 className="modal-title mb-0 fw-bold" style={{color: '#212529'}}>
                <i className="fas fa-brain me-2"></i>
                Tipo de Reunião
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowModalTipo(false)}
              ></button>
            </div>
            
            <div className="modal-body">
              <p className="text-muted mb-3">
                <i className="fas fa-info-circle me-2"></i>
                Selecione o tipo de reunião para uma análise mais precisa:
              </p>
              
              <select 
                className="form-select form-select-lg"
                value={tipoReuniaoSelecionado}
                onChange={(e) => setTipoReuniaoSelecionado(e.target.value)}
                onClick={(e) => e.stopPropagation()}
              >
                {tiposReuniao.map(tipo => (
                  <option key={tipo.id} value={tipo.tipo_reuniao}>
                    {tipo.nome_exibicao}
                  </option>
                ))}
              </select>

              <div className="alert alert-info mt-3 mb-0">
                <small>
                  <i className="fas fa-lightbulb me-2"></i>
                  A análise será personalizada de acordo com o tipo selecionado.
                </small>
              </div>
            </div>
            

<div className="modal-footer">
  <button
    className="btn btn-secondary"
    onClick={() => setShowModalTipo(false)}
  >
    <i className="fas fa-times me-2"></i>
    Cancelar
  </button>
  <button
    className="btn btn-primary"
    onClick={confirmarAnalise}
    style={{background: 'linear-gradient(135deg, #d610b5 0%, #a30c8a 100%)', border: 'none'}}
  >
    <i className="fas fa-brain me-2"></i>
    Analisar com Memor.IA
  </button>
</div>
          </div>
        </div>
      </div>
    );
  };

  const renderModalAnalise = () => {
    if (!analiseAtual) return null;

    const tipoReuniao = analiseAtual.metadata?.tipo_reuniao;

    // Participantes identificados pela IA — internos (equipe) e externos (cliente)
    const _norm = (s) => (s || '').trim().toLowerCase();
    const internosRaw = (analiseAtual.analise_operadores || [])
      .map(o => (o.nome || '').trim())
      .filter(Boolean);
    // Remove nomes repetidos (mesmo participante citado mais de uma vez)
    const participantesInternos = internosRaw.filter(
      (n, i) => internosRaw.findIndex(m => _norm(m) === _norm(n)) === i
    );
    const nomeCliente = (analiseAtual.prospect_info?.nome || '').trim();
    // Em reuniões 1:1 (gestão) todos são internos — não há cliente externo.
    // Também evita listar como externo alguém que já está entre os internos.
    const participantesExternos = (tipoReuniao === 'gestao' || !nomeCliente
      || participantesInternos.some(n => _norm(n) === _norm(nomeCliente)))
      ? []
      : [nomeCliente];
    const temParticipantes = participantesInternos.length > 0 || participantesExternos.length > 0;

    // Empresa/cliente ainda não confirmado (não vale para reuniões internas 1:1)
    const empresaNaoIdentificada = tipoReuniao !== 'gestao'
      && !clienteSelecionadoId
      && !(mostrarFormNovo && nomeClienteManual.trim());

    // Produto/Serviço (ou Setor, nas 1:1) obrigatório
    const faltaProduto = tipoReuniao === 'gestao'
      ? !produtoSelecionado
      : produtosSelecionados.length === 0;
    // Nº de domínio obrigatório para reuniões de cliente (nas 1:1 internas não exige)
    const faltaDominio = tipoReuniao !== 'gestao' && !String(numeroDominio || '').trim();
    // Trava do salvamento: exige empresa, produto e domínio preenchidos
    const bloquearSalvar = empresaNaoIdentificada || faltaProduto || faltaDominio;

    return (
      <div 
        className={`modal fade ${showModalAnalise ? 'show d-block' : ''}`} 
        style={{backgroundColor: 'rgba(0,0,0,0.5)'}}
        onClick={() => setShowModalAnalise(false)}
      >
        <div 
          className="modal-dialog modal-dialog-scrollable"
          style={{maxWidth: '95vw', width: '95vw'}}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content">
            <div className="modal-header" style={{backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef'}}>
              <h5 className="modal-title mb-0 fw-bold" style={{color: '#212529'}}>
                <i className="fas fa-brain me-2"></i>
                Análise Inteligente da Reunião
                {tipoReuniao && (
                  <span className="badge bg-light text-dark ms-2">
                    {tiposReuniao.find(t => t.tipo_reuniao === tipoReuniao)?.nome_exibicao || tipoReuniao}
                  </span>
                )}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowModalAnalise(false)}
              ></button>
            </div>
            
            <div className="modal-body">
              {/* Metadados */}
              {analiseAtual.metadata && (
                <div className="card mb-3 border-primary">
                  <div className="card-body">
                    <h6 className="text-primary mb-3">
                      <i className="fas fa-info-circle me-2"></i>
                      Informações da Reunião
                    </h6>
                    <div className="row g-2">
                      <div className="col-md-3">
                        <small className="text-muted d-block">Cliente</small>
                        <strong>{analiseAtual.metadata.cliente}</strong>
                      </div>
                      <div className="col-md-5">
                        <small className="text-muted d-block">Assunto</small>
                        <strong>{analiseAtual.metadata.titulo}</strong>
                      </div>
                      <div className="col-md-2">
                        <small className="text-muted d-block">Data</small>
                        <strong>
                          {analiseAtual.metadata.data_reuniao ? 
                            formatarData(analiseAtual.metadata.data_reuniao) : 
                            '-'
                          }
                        </strong>
                      </div>
                      <div className="col-md-2">
                        <small className="text-muted d-block">Horário</small>
                        <strong>{analiseAtual.metadata.hora}</strong>
                      </div>
                    </div>

                    {/* Participantes identificados na reunião */}
                    {temParticipantes && (
                      <div className="mt-3 pt-3 border-top">
                        <small className="text-muted d-block mb-2">
                          <i className="fas fa-users me-1"></i>Participantes identificados
                        </small>
                        <div className="d-flex flex-wrap gap-2 align-items-center">
                          {participantesInternos.map((nome, i) => (
                            <span
                              key={`int-${i}`}
                              className="badge d-inline-flex align-items-center"
                              style={{background: '#fdf2fa', color: '#a30c8a', border: '1px solid #f5d0e8', fontSize: '0.82rem', fontWeight: 600}}
                              title="Equipe interna (Comece Hub)"
                            >
                              <i className="fas fa-user-tie me-1"></i>{nome}
                            </span>
                          ))}
                          {participantesExternos.map((nome, i) => (
                            <span
                              key={`ext-${i}`}
                              className="badge d-inline-flex align-items-center"
                              style={{background: '#eef4ff', color: '#0d47a1', border: '1px solid #c9dcff', fontSize: '0.82rem', fontWeight: 600}}
                              title="Cliente / participante externo"
                            >
                              <i className="fas fa-user me-1"></i>{nome}
                            </span>
                          ))}
                        </div>
                        {(participantesInternos.length > 0 && participantesExternos.length > 0) && (
                          <small className="text-muted d-block mt-2" style={{fontSize: '0.72rem'}}>
                            <span style={{color: '#a30c8a'}}>●</span> Equipe interna
                            <span className="ms-3" style={{color: '#0d47a1'}}>●</span> Cliente / externo
                          </small>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Empresa Identificada */}
              <div
                className="card mb-3"
                style={{
                  position: 'relative',
                  zIndex: mostrarSugestoesEmpresa ? 1070 : 'auto',
                  ...(empresaNaoIdentificada
                    ? {border: '1px solid #ffc107', background: '#fff9e6'}
                    : {border: 0, background: '#f8f9fa'}),
                }}
              >
                <div className="card-body py-2 px-3">
                  {empresaNaoIdentificada && (
                    <div className="d-flex align-items-start gap-2 mb-2 pb-2 border-bottom" style={{borderColor: '#ffe08a'}}>
                      <i className="fas fa-triangle-exclamation mt-1" style={{color: '#e0a800'}}></i>
                      <div>
                        <strong className="d-block" style={{color: '#9a7400', fontSize: '0.9rem'}}>
                          Cliente não identificado
                        </strong>
                        <small className="text-muted">
                          A Memor.IA não reconheceu a empresa desta reunião. Selecione a empresa na lista
                          ou clique em <strong>+</strong> para cadastrar uma nova antes de salvar.
                        </small>
                      </div>
                    </div>
                  )}
                  <div className="d-flex align-items-center gap-2 flex-wrap">
                    <small className="text-muted">
                      <i className="fas fa-building me-1"></i>
                      <strong>Empresa:</strong>
                    </small>

                    {/* Autocomplete de empresa: digita e sugere clientes cadastrados */}
                    {!mostrarFormNovo && (
                      <div style={{position: 'relative', width: '340px', maxWidth: '100%'}}>
                        <div className="input-group input-group-sm">
                          <span className="input-group-text bg-white">
                            <i className="fas fa-search text-muted"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Digite para buscar a empresa cadastrada..."
                            value={buscaEmpresa}
                            onChange={(e) => {
                              setBuscaEmpresa(e.target.value);
                              setMostrarSugestoesEmpresa(true);
                              if (clienteSelecionadoId) { setClienteSelecionadoId(''); setNumeroDominio(''); }
                            }}
                            onFocus={() => setMostrarSugestoesEmpresa(true)}
                            onBlur={() => setTimeout(() => setMostrarSugestoesEmpresa(false), 150)}
                          />
                          {clienteSelecionadoId && (
                            <button
                              className="btn btn-outline-secondary"
                              type="button"
                              title="Limpar seleção"
                              onClick={() => { setClienteSelecionadoId(''); setBuscaEmpresa(''); setNumeroDominio(''); setMostrarSugestoesEmpresa(true); }}
                            >
                              <i className="fas fa-times"></i>
                            </button>
                          )}
                        </div>

                        {mostrarSugestoesEmpresa && (() => {
                          const termo = buscaEmpresa.trim().toLowerCase();
                          const sugestoes = clientesLista
                            .filter(c => !termo || (c.empresa || '').toLowerCase().includes(termo));
                          return (
                            <div
                              className="border rounded shadow-sm bg-white"
                              style={{position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 1060, maxHeight: '320px', overflowY: 'auto', marginTop: '2px'}}
                            >
                              <div className="px-3 py-1 small text-muted border-bottom bg-light" style={{position: 'sticky', top: 0, fontSize: '0.72rem'}}>
                                {sugestoes.length === 0
                                  ? 'Nenhuma empresa encontrada'
                                  : `${sugestoes.length} empresa(s) · role para ver todas`}
                              </div>
                              {sugestoes.length === 0 ? (
                                <div className="px-3 py-2 small text-muted">
                                  Nenhuma empresa encontrada. Clique em <strong>+</strong> para cadastrar.
                                </div>
                              ) : sugestoes.map(c => (
                                <button
                                  key={c.id}
                                  type="button"
                                  className="dropdown-item px-3 py-2 text-wrap"
                                  style={{fontSize: '0.85rem', cursor: 'pointer'}}
                                  onMouseDown={(e) => e.preventDefault()}
                                  onClick={() => {
                                    handleSelecionarCliente(String(c.id));
                                    setBuscaEmpresa(c.empresa || '');
                                    setMostrarSugestoesEmpresa(false);
                                  }}
                                >
                                  <i className="fas fa-building me-2 text-muted"></i>
                                  <strong>{c.empresa}</strong>
                                  {c.numero_dominio ? <span className="text-muted"> · domínio {c.numero_dominio}</span> : null}
                                </button>
                              ))}
                            </div>
                          );
                        })()}
                      </div>
                    )}

                    {/* Nº Domínio inline */}
                    {clienteSelecionadoId && !mostrarFormNovo && (
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        style={{width: '90px'}}
                        placeholder="Domínio"
                        value={numeroDominio}
                        onChange={(e) => setNumeroDominio(e.target.value)}
                      />
                    )}

                    {/* Botão + */}
                    <button
                      className={`btn btn-sm ${mostrarFormNovo ? 'btn-success' : 'btn-outline-secondary'}`}
                      style={{padding: '2px 8px'}}
                      onClick={() => {
                        const abrindo = !mostrarFormNovo;
                        setMostrarFormNovo(abrindo);
                        setClienteSelecionadoId('');
                        setMostrarSugestoesEmpresa(false);
                        if (abrindo) {
                          // Pré-preenche o nome com o que foi digitado na busca
                          setNomeClienteManual(buscaEmpresa.trim());
                          // Sugere o próximo domínio: maior cadastrado + 1
                          const maxDominio = clientesLista.reduce(
                            (max, c) => Math.max(max, Number(c.numero_dominio) || 0), 0
                          );
                          setNumeroDominio(String(maxDominio + 1));
                        } else {
                          setNomeClienteManual('');
                          setNumeroDominio('');
                        }
                      }}
                      title="Cadastrar nova empresa"
                    >
                      <i className="fas fa-plus"></i>
                    </button>
                  </div>

                  {/* Formulário nova empresa */}
                  {mostrarFormNovo && (
                    <div className="mt-2 p-2 rounded" style={{background: '#f0fff4', border: '1px solid #c3e6cb'}}>
                      <small className="fw-bold text-success d-block mb-2">
                        <i className="fas fa-plus-circle me-1"></i>Nova empresa:
                      </small>
                      <div className="row g-2">
                        <div className="col-md-8">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Nome da empresa..."
                            value={nomeClienteManual}
                            onChange={(e) => setNomeClienteManual(e.target.value)}
                          />
                        </div>
                        <div className="col-md-4">
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            placeholder="Nº Domínio"
                            value={numeroDominio}
                            onChange={(e) => setNumeroDominio(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {tipoReuniao === 'gestao' ? (
                /* Reunião 1:1 — Setor + Gestor + Operador */
                <div className="card mb-3 border-0" style={{background: '#fdf2fa', border: '1px solid #f5d0e8'}}>
                  <div className="card-body py-3 px-3">
                    <div className="d-flex align-items-center mb-3">
                      <span className="badge" style={{background: '#d6336c', fontSize: '0.82rem'}}>
                        <i className="fas fa-user-friends me-1"></i>
                        Reunião 1:1 · Gestão de Pessoas
                      </span>
                      <small className="text-muted ms-2">
                        Confirme o setor, o gestor e o colaborador desta conversa.
                      </small>
                    </div>
                    <div className="row g-2">
                      <div className="col-md-4">
                        <label className="form-label small text-muted mb-1">
                          <i className="fas fa-sitemap me-1"></i>Setor
                        </label>
                        <select
                          className="form-select form-select-sm"
                          value={produtoSelecionado}
                          onChange={(e) => setProdutoSelecionado(e.target.value)}
                        >
                          <option value="">— selecione —</option>
                          {produtoSelecionado && !SETORES.includes(produtoSelecionado) && (
                            <option value={produtoSelecionado}>{produtoSelecionado}</option>
                          )}
                          {SETORES.map(s => (
                            <option key={s} value={s}>{s}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label small text-muted mb-1">
                          <i className="fas fa-user-tie me-1"></i>Gestor
                        </label>
                        <select
                          className="form-select form-select-sm"
                          value={gestorSelecionado}
                          onChange={(e) => setGestorSelecionado(e.target.value)}
                        >
                          <option value="">— selecione —</option>
                          {equipeInterna.map(m => (
                            <option key={`g-${m.id}`} value={m.nome}>
                              {m.nome}{m.is_gestor ? (m.gestor_setor ? ` · Gestor ${m.gestor_setor}` : ' · Gestor') : ''}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label small text-muted mb-1">
                          <i className="fas fa-user me-1"></i>Colaborador (Operador)
                        </label>
                        <select
                          className="form-select form-select-sm"
                          value={operadorSelecionado}
                          onChange={(e) => setOperadorSelecionado(e.target.value)}
                        >
                          <option value="">— selecione —</option>
                          {/* Colaborador identificado pela IA que ainda não é cadastrado no Memor.IA */}
                          {operadorSelecionado
                            && !equipeInterna.some(m => m.nome === operadorSelecionado) && (
                            <option value={operadorSelecionado}>
                              {operadorSelecionado} · não cadastrado
                            </option>
                          )}
                          {equipeInterna.map(m => (
                            <option key={`o-${m.id}`} value={m.nome}>
                              {m.nome}{m.setor ? ` · ${m.setor}` : ''}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                /* Produto / Serviço — múltiplos + cadastrar novo */
                <div
                  className="card mb-3"
                  style={produtosSelecionados.length === 0
                    ? {border: '1px solid #ffc107', background: '#fff9e6'}
                    : {border: 0, background: '#f8f9fa'}}
                >
                  <div className="card-body py-2 px-3">
                    <small style={{color: produtosSelecionados.length === 0 ? '#9a7400' : '#6c757d'}}>
                      <i className={`fas ${produtosSelecionados.length === 0 ? 'fa-triangle-exclamation' : 'fa-box-open'} me-1`}></i>
                      <strong>Produtos / Serviços tratados na reunião:</strong>
                      <span className="ms-1" style={{fontWeight: 400}}>(pode marcar mais de um)</span>
                    </small>

                    {/* Chips selecionáveis */}
                    <div className="d-flex flex-wrap gap-2 mt-2">
                      {produtosLista.map(p => {
                        const ativo = produtosSelecionados.includes(p);
                        return (
                          <button
                            key={p}
                            type="button"
                            onClick={() => !modoVisualizacao && toggleProduto(p)}
                            disabled={modoVisualizacao}
                            className="btn btn-sm"
                            style={{
                              borderRadius: '20px',
                              padding: '3px 12px',
                              fontSize: '0.82rem',
                              fontWeight: 600,
                              border: `1px solid ${ativo ? '#00205b' : '#ced4da'}`,
                              background: ativo ? '#00205b' : '#fff',
                              color: ativo ? '#fff' : '#495057',
                            }}
                          >
                            {ativo && <i className="fas fa-check me-1"></i>}
                            {p}
                          </button>
                        );
                      })}
                      {/* Produtos selecionados que não estão na lista (ex.: análises antigas) */}
                      {produtosSelecionados.filter(p => !produtosLista.includes(p)).map(p => (
                        <button
                          key={p}
                          type="button"
                          onClick={() => !modoVisualizacao && toggleProduto(p)}
                          disabled={modoVisualizacao}
                          className="btn btn-sm"
                          style={{
                            borderRadius: '20px', padding: '3px 12px', fontSize: '0.82rem',
                            fontWeight: 600, border: '1px solid #00205b', background: '#00205b', color: '#fff',
                          }}
                        >
                          <i className="fas fa-check me-1"></i>{p}
                        </button>
                      ))}
                    </div>

                    {/* Cadastrar novo produto */}
                    {!modoVisualizacao && (
                      <div className="d-flex align-items-center gap-2 mt-3">
                        <i className="fas fa-plus text-muted" style={{fontSize: '0.8rem'}}></i>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          style={{maxWidth: '260px'}}
                          placeholder="Novo produto (ex.: Recuperação Tributária)"
                          value={novoProdutoTexto}
                          onChange={(e) => setNovoProdutoTexto(e.target.value)}
                          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); cadastrarNovoProduto(); } }}
                        />
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-primary"
                          onClick={cadastrarNovoProduto}
                          disabled={salvandoProduto || !novoProdutoTexto.trim()}
                        >
                          {salvandoProduto
                            ? <span className="spinner-border spinner-border-sm"></span>
                            : 'Cadastrar'}
                        </button>
                      </div>
                    )}

                    {produtosSelecionados.length === 0 && (
                      <small className="text-muted d-block mt-2">
                        Selecione ao menos um produto/serviço tratado nesta reunião antes de salvar.
                      </small>
                    )}
                  </div>
                </div>
              )}

              {/* Classificação, Nota, Interesse e Estágio */}
              <div className="row g-3 mb-3">
                <div className="col-md-3">
                  <div className="card h-100">
                    <div className="card-body text-center">
                      <small className="text-muted d-block mb-2">
                        <i className="fas fa-star me-1"></i>
                        Classificação
                      </small>
                      <h3 className="mb-0">
                        <span className={`badge ${getBadgeClassificacao(analiseAtual.classificacao)}`}>
                          {analiseAtual.classificacao?.toUpperCase().replace('_', ' ')}
                        </span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card h-100">
                    <div className="card-body text-center">
                      <small className="text-muted d-block mb-2">
                        <i className="fas fa-chart-line me-1"></i>
                        Nota
                      </small>
                      <h3 className="mb-0">
                        <span className={`badge ${
                          analiseAtual.nota >= 8 ? 'bg-success' :
                          analiseAtual.nota >= 6 ? 'bg-primary' :
                          analiseAtual.nota >= 4 ? 'bg-warning text-dark' : 'bg-danger'
                        }`} style={{fontSize: '1.5rem'}}>
                          {analiseAtual.nota}/10
                        </span>
                      </h3>
                    </div>
                  </div>
                </div>
                {analiseAtual.interesse_nivel && (
                  <div className="col-md-3">
                    <div className="card h-100">
                      <div className="card-body text-center">
                        <small className="text-muted d-block mb-2">
                          <i className="fas fa-fire me-1"></i>
                          Interesse do Cliente
                        </small>
                        <span className={`badge fs-6 ${
                          parseInt(analiseAtual.interesse_nivel) >= 7 ? 'bg-success' :
                          parseInt(analiseAtual.interesse_nivel) >= 5 ? 'bg-warning text-dark' : 'bg-secondary'
                        }`}>
                          {analiseAtual.interesse_nivel}/10
                        </span>
                      </div>
                    </div>
                  </div>
                )}
                {analiseAtual.estagio_venda && tipoReuniao === 'comercial' && (
                  <div className="col-md-3">
                    <div className="card h-100">
                      <div className="card-body text-center">
                        <small className="text-muted d-block mb-2">
                          <i className="fas fa-funnel-dollar me-1"></i>
                          Estágio do Funil
                        </small>
                        <span className="badge bg-primary fs-6">
                          {analiseAtual.estagio_venda.charAt(0).toUpperCase() + analiseAtual.estagio_venda.slice(1)}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Resumo */}
              {analiseAtual.resumo && (
                <div className="card mb-3 border-info">
                  <div className="card-body">
                    <h6 className="text-info mb-2">
                      <i className="fas fa-file-alt me-2"></i>
                      Resumo Executivo
                    </h6>
                    <p className="mb-0">{analiseAtual.resumo}</p>
                  </div>
                </div>
              )}

              {/* Prospect / Cliente Info */}
              {analiseAtual.prospect_info && (
                <div className="card mb-3">
                  <div className="card-body">
                    <h6 className="mb-3">
                      <i className="fas fa-user-tie me-2"></i>
                      {tipoReuniao === 'comercial' ? 'Informações do Prospect' : 'Informações do Cliente'}
                    </h6>
                    <div className="row g-2">
                      {analiseAtual.prospect_info.nome && (
                        <div className="col-md-6">
                          <small className="text-muted d-block">Nome</small>
                          <strong>{analiseAtual.prospect_info.nome}</strong>
                        </div>
                      )}
                      {analiseAtual.prospect_info.empresa && (
                        <div className="col-md-6">
                          <small className="text-muted d-block">Empresa</small>
                          <strong>{analiseAtual.prospect_info.empresa}</strong>
                        </div>
                      )}
                      {analiseAtual.prospect_info.cargo && (
                        <div className="col-md-6">
                          <small className="text-muted d-block">Cargo</small>
                          <strong>{analiseAtual.prospect_info.cargo}</strong>
                        </div>
                      )}
                      {analiseAtual.prospect_info.orcamento_estimado && (
                        <div className="col-md-6">
                          <small className="text-muted d-block">Orçamento Estimado</small>
                          <strong className="text-success">{analiseAtual.prospect_info.orcamento_estimado}</strong>
                        </div>
                      )}
                      {analiseAtual.prospect_info.dor_principal && (
                        <div className="col-12">
                          <small className="text-muted d-block">Dor Principal</small>
                          <p className="mb-0">{analiseAtual.prospect_info.dor_principal}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Objeções */}
              {analiseAtual.objecoes && analiseAtual.objecoes.length > 0 && (
                <div className="card mb-3" style={{borderLeft: '4px solid #dc3545'}}>
                  <div className="card-body">
                    <h6 className="text-danger mb-3">
                      <i className="fas fa-hand-paper me-2"></i>
                      Objeções Levantadas ({analiseAtual.objecoes.length})
                    </h6>
                    <div className="d-flex flex-wrap gap-2">
                      {analiseAtual.objecoes.map((obj, idx) => (
                        <span key={idx} className="badge bg-danger" style={{fontSize: '0.85rem', whiteSpace: 'normal', textAlign: 'left'}}>
                          <i className="fas fa-times-circle me-1"></i>
                          {obj}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Concorrentes */}
              {analiseAtual.concorrentes_mencionados && analiseAtual.concorrentes_mencionados.length > 0 && (
                <div className="card mb-3" style={{borderLeft: '4px solid #6f42c1'}}>
                  <div className="card-body">
                    <h6 className="mb-3" style={{color: '#6f42c1'}}>
                      <i className="fas fa-chess-knight me-2"></i>
                      Concorrentes Mencionados
                    </h6>
                    <div className="d-flex flex-wrap gap-2">
                      {analiseAtual.concorrentes_mencionados.map((conc, idx) => (
                        <span key={idx} className="badge" style={{background: '#6f42c1', fontSize: '0.85rem'}}>
                          {conc}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Produtos / Serviços de Interesse */}
              {analiseAtual.produtos_servicos_interesse && analiseAtual.produtos_servicos_interesse.length > 0 && (
                <div className="card mb-3" style={{borderLeft: '4px solid #198754'}}>
                  <div className="card-body">
                    <h6 className="text-success mb-3">
                      <i className="fas fa-box-open me-2"></i>
                      Produtos / Serviços de Interesse
                    </h6>
                    <div className="d-flex flex-wrap gap-2">
                      {analiseAtual.produtos_servicos_interesse.map((prod, idx) => (
                        <span key={idx} className="badge bg-success" style={{fontSize: '0.85rem'}}>
                          <i className="fas fa-check me-1"></i>
                          {prod}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Pontos Críticos */}
              {analiseAtual.pontos_criticos && analiseAtual.pontos_criticos.length > 0 && (
                <div className="card mb-3" style={{ borderLeft: '4px solid #d610b5' }}>
                  <div className="card-body">
                    <h6 className="mb-3" style={{ color: '#d610b5' }}>
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      Pontos Críticos ({analiseAtual.pontos_criticos.length})
                    </h6>
                    {analiseAtual.pontos_criticos.map((ponto, idx) => {
                      const tipoNorm = (ponto.tipo || '').toLowerCase();
                      const classeAlerta = tipoNorm.startsWith('oportunidade')
                        ? 'alert-success'
                        : tipoNorm.startsWith('risco')
                        ? 'alert-danger'
                        : 'alert-warning';
                      return (
                      <div key={idx} className={`alert ${classeAlerta} mb-2`}>
                        <div className="d-flex justify-content-between align-items-start">
                          <div className="flex-grow-1">
                            <strong className="text-uppercase">{ponto.tipo}</strong>
                            <p className="mb-0 mt-1">{ponto.descricao}</p>
                          </div>
                          <span className={`badge ms-2 ${
                            ponto.urgencia === 'alta' ? 'bg-danger' :
                            ponto.urgencia === 'media' ? 'bg-warning text-dark' : 'bg-info'
                          }`}>
                            {ponto.urgencia}
                          </span>
                        </div>
                      </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Análise por Operador */}
              {analiseAtual.analise_operadores && analiseAtual.analise_operadores.length > 0 ? (
                <div className="mb-3">
                  <h6 className="mb-3" style={{color: '#fd7e14'}}>
                    <i className="fas fa-chalkboard-teacher me-2"></i>
                    Análise por Operador ({analiseAtual.analise_operadores.length})
                  </h6>
                  <div className="row g-3">
                    {analiseAtual.analise_operadores.map((op, idx) => (
                      <div key={idx} className="col-md-6">
                        <div className="card h-100" style={{borderLeft: '4px solid #fd7e14', background: '#fff8f3'}}>
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <h6 className="mb-0 fw-bold" style={{color: '#fd7e14'}}>
                                <i className="fas fa-user-circle me-2"></i>
                                {op.nome}
                                {op.id_usuario && (
                                  <span className="badge bg-secondary ms-2" style={{fontSize: '0.72rem', fontWeight: 'normal', verticalAlign: 'middle'}}>
                                    ID {op.id_usuario}
                                  </span>
                                )}
                              </h6>
                              <div className="d-flex align-items-center gap-2">
                                {op.nota !== undefined && op.nota !== null && (
                                  <span className={`badge ${
                                    op.nota >= 8 ? 'bg-success' :
                                    op.nota >= 6 ? 'bg-primary' :
                                    op.nota >= 4 ? 'bg-warning text-dark' : 'bg-danger'
                                  }`} style={{fontSize: '0.9rem'}}>
                                    {op.nota}/10
                                  </span>
                                )}
                                {op.objetivo_melhoria && (
                                  <span className="badge" style={{background: '#fd7e14', fontSize: '0.78rem'}}>
                                    <i className="fas fa-bullseye me-1"></i>
                                    {op.objetivo_melhoria}
                                  </span>
                                )}
                              </div>
                            </div>
                            {op.ponto_forte && (
                              <div className="mb-2">
                                <small className="fw-bold text-success d-block mb-1">
                                  <i className="fas fa-thumbs-up me-1"></i>
                                  Ponto Forte
                                </small>
                                <p className="mb-0 small">{op.ponto_forte}</p>
                              </div>
                            )}
                            {op.ponto_melhoria && (
                              <div>
                                <small className="fw-bold text-danger d-block mb-1">
                                  <i className="fas fa-arrow-up me-1"></i>
                                  O que Melhorar
                                </small>
                                <p className="mb-0 small">{op.ponto_melhoria}</p>
                              </div>
                            )}
                            {op.competencias && op.competencias.length > 0 && (
                              <div className="mt-3">
                                <small className="fw-bold d-block mb-2" style={{ color: '#fd7e14' }}>
                                  <i className="fas fa-bullseye me-1"></i>
                                  Competências Consultivas
                                </small>
                                <div className="d-flex flex-wrap gap-1">
                                  {op.competencias.map((c, k) => {
                                    const cfg = c.status === 'demonstrou'
                                      ? { bg: '#e3f2ec', cor: '#1a7f5a', icon: 'fa-check' }
                                      : c.status === 'nao_demonstrou'
                                      ? { bg: '#fdecea', cor: '#b3372f', icon: 'fa-times' }
                                      : { bg: '#eef0f2', cor: '#6c757d', icon: 'fa-minus' };
                                    return (
                                      <span
                                        key={k}
                                        title={c.evidencia || 'Não se aplica nesta reunião'}
                                        style={{
                                          background: cfg.bg, color: cfg.cor,
                                          fontSize: '0.72rem', fontWeight: 600,
                                          padding: '3px 8px', borderRadius: 999,
                                          cursor: c.evidencia ? 'help' : 'default',
                                        }}
                                      >
                                        <i className={`fas ${cfg.icon} me-1`}></i>
                                        {LABEL_COMPETENCIA[c.competencia] || c.competencia}
                                        {c.nota !== null && c.nota !== undefined && ` · ${c.nota}`}
                                      </span>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (analiseAtual['melhorias_do_operador'] || analiseAtual['melhorias no operador']) ? (
                <div className="card mb-3" style={{borderLeft: '4px solid #fd7e14', background: '#fff8f3'}}>
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
                      <h6 className="mb-0" style={{color: '#fd7e14'}}>
                        <i className="fas fa-chalkboard-teacher me-2"></i>
                        Melhorias no Operador
                      </h6>
                      {analiseAtual['objetivos_de_melhoia'] && (
                        <span className="badge" style={{background: '#fd7e14', fontSize: '0.85rem'}}>
                          <i className="fas fa-bullseye me-1"></i>
                          {analiseAtual['objetivos_de_melhoia']}
                        </span>
                      )}
                    </div>
                    <p className="mb-0" style={{whiteSpace: 'pre-line'}}>
                      {analiseAtual['melhorias_do_operador'] || analiseAtual['melhorias no operador']}
                    </p>
                  </div>
                </div>
              ) : null}

              {/* Problemas Identificados (Serviço) */}
              {analiseAtual.problemas_identificados && analiseAtual.problemas_identificados.length > 0 && (
                <div className="card mb-3 border-danger">
                  <div className="card-body">
                    <h6 className="text-danger mb-3">
                      <i className="fas fa-bug me-2"></i>
                      Problemas Identificados ({analiseAtual.problemas_identificados.length})
                    </h6>
                    {analiseAtual.problemas_identificados.map((problema, idx) => (
                      <div key={idx} className="alert alert-danger mb-2">
                        <div className="d-flex justify-content-between">
                          <div>
                            <span className="badge bg-secondary me-2">{problema.tipo}</span>
                            {problema.descricao}
                          </div>
                          <span className={`badge ${
                            problema.criticidade === 'alta' ? 'bg-danger' :
                            problema.criticidade === 'media' ? 'bg-warning text-dark' : 'bg-info'
                          }`}>
                            {problema.criticidade}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Action Items */}
              {analiseAtual.action_items && analiseAtual.action_items.length > 0 && (
                <div className="card mb-3 border-success">
                  <div className="card-body">
                    <h6 className="text-success mb-3">
                      <i className="fas fa-tasks me-2"></i>
                      Ações e Tarefas ({analiseAtual.action_items.length})
                    </h6>
                    <div className="table-responsive">
                      <table className="table table-sm table-hover">
                        <thead className="table-light">
                          <tr>
                            <th>Responsável</th>
                            <th>Tarefa</th>
                            <th>Prazo</th>
                          </tr>
                        </thead>
                        <tbody>
                          {analiseAtual.action_items.map((item, idx) => (
                            <tr key={idx}>
                              <td><strong>{item.responsavel}</strong></td>
                              <td>{item.tarefa || item.acao}</td>
                              <td>
                                <span className="badge bg-primary">
                                  {item.prazo || 'Não definido'}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}

              {/* Próximos Passos */}
              {analiseAtual.proximos_passos && analiseAtual.proximos_passos.length > 0 && (
                <div className="card mb-3">
                  <div className="card-body">
                    <h6 className="mb-2">
                      <i className="fas fa-arrow-right me-2"></i>
                      Próximos Passos
                    </h6>
                    <ol className="mb-0">
                      {analiseAtual.proximos_passos.map((passo, idx) => (
                        <li key={idx} className="mb-2">
                          {typeof passo === 'string' ? passo : 
                            `${passo.responsavel}: ${passo.acao} (${passo.prazo})`
                          }
                        </li>
                      ))}
                    </ol>
                  </div>
                </div>
              )}

              {/* Anotações IA ANOTAR */}
              {analiseAtual.anotacoes && analiseAtual.anotacoes.length > 0 && (
                <div className="card mb-3" style={{borderLeft: '4px solid #0d6efd', background: '#f0f4ff'}}>
                  <div className="card-body">
                    <h6 className="mb-3 text-primary">
                      <i className="fas fa-microphone-alt me-2"></i>
                      Anotações da Reunião — "IA ANOTAR" ({analiseAtual.anotacoes.length})
                    </h6>
                    {analiseAtual.anotacoes.map((anot, idx) => (
                      <div key={idx} className="d-flex align-items-start mb-2 p-2 rounded" style={{background: '#fff', border: '1px solid #c7d8ff'}}>
                        <div className="me-3 mt-1">
                          <span className="badge bg-primary rounded-pill" style={{fontSize: '0.75rem'}}>
                            {idx + 1}
                          </span>
                        </div>
                        <div className="flex-grow-1">
                          {anot.falante && (
                            <small className="fw-bold text-primary d-block mb-1">
                              <i className="fas fa-user me-1"></i>
                              {anot.falante}
                            </small>
                          )}
                          <p className="mb-0">{anot.conteudo}</p>
                        </div>
                        <div className="ms-2">
                          <i className="fas fa-thumbtack text-primary" style={{opacity: 0.5}}></i>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Sentimento das Palavras */}
              {analiseAtual.sentimento_palavras && (
                <div className="card mb-3" style={{borderLeft: '4px solid #6610f2'}}>
                  <div className="card-body">
                    <h6 className="mb-3" style={{color: '#6610f2'}}>
                      <i className="fas fa-heart-pulse me-2"></i>
                      Análise de Sentimento das Palavras
                    </h6>
                    <div className="row g-3">
                      {analiseAtual.sentimento_palavras.positivas && analiseAtual.sentimento_palavras.positivas.length > 0 && (
                        <div className="col-md-6">
                          <small className="fw-bold text-success d-block mb-2">
                            <i className="fas fa-smile me-1"></i>
                            Palavras que geram sentimento POSITIVO
                          </small>
                          <div className="d-flex flex-wrap gap-2">
                            {analiseAtual.sentimento_palavras.positivas.map((item, idx) => (
                              <div key={idx} className="d-flex flex-column align-items-center">
                                <span className="badge bg-success px-3 py-2" style={{fontSize: '0.85rem'}} title={typeof item === 'string' ? item : item.palavra}>
                                  <i className="fas fa-thumbs-up me-1"></i>
                                  {encurtar(typeof item === 'string' ? item : item.palavra)}
                                </span>
                                {typeof item !== 'string' && (item.falante || item.contexto) && (
                                  <small className="text-muted mt-1" style={{fontSize: '0.7rem', maxWidth: '120px', textAlign: 'center'}}>
                                    {item.falante ? <strong>{item.falante}</strong> : null}
                                    {item.falante && item.contexto ? ' — ' : ''}
                                    {item.contexto}
                                  </small>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {analiseAtual.sentimento_palavras.negativas && analiseAtual.sentimento_palavras.negativas.length > 0 && (
                        <div className="col-md-6">
                          <small className="fw-bold text-danger d-block mb-2">
                            <i className="fas fa-frown me-1"></i>
                            Palavras que geram sentimento NEGATIVO
                          </small>
                          <div className="d-flex flex-wrap gap-2">
                            {analiseAtual.sentimento_palavras.negativas.map((item, idx) => (
                              <div key={idx} className="d-flex flex-column align-items-center">
                                <span className="badge bg-danger px-3 py-2" style={{fontSize: '0.85rem'}} title={typeof item === 'string' ? item : item.palavra}>
                                  <i className="fas fa-thumbs-down me-1"></i>
                                  {encurtar(typeof item === 'string' ? item : item.palavra)}
                                </span>
                                {typeof item !== 'string' && (item.falante || item.contexto) && (
                                  <small className="text-muted mt-1" style={{fontSize: '0.7rem', maxWidth: '120px', textAlign: 'center'}}>
                                    {item.falante ? <strong>{item.falante}</strong> : null}
                                    {item.falante && item.contexto ? ' — ' : ''}
                                    {item.contexto}
                                  </small>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                    {analiseAtual.sentimento_palavras.sentimento_geral && (
                      <div className="mt-3 p-2 rounded" style={{background: '#f5f0ff'}}>
                        <small className="fw-bold" style={{color: '#6610f2'}}>
                          <i className="fas fa-chart-pie me-1"></i>
                          Sentimento geral da conversa:
                        </small>
                        <span className={`badge ms-2 ${
                          analiseAtual.sentimento_palavras.sentimento_geral === 'positivo' ? 'bg-success' :
                          analiseAtual.sentimento_palavras.sentimento_geral === 'negativo' ? 'bg-danger' : 'bg-secondary'
                        }`}>
                          {analiseAtual.sentimento_palavras.sentimento_geral.toUpperCase()}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Observações */}
              {analiseAtual.observacoes && (
                <div className="card mb-3">
                  <div className="card-body">
                    <h6 className="mb-2">
                      <i className="fas fa-sticky-note me-2"></i>
                      Observações
                    </h6>
                    <p className="mb-0 text-muted">{analiseAtual.observacoes}</p>
                  </div>
                </div>
              )}
            </div>
            
            <div className="modal-footer">
              {codigoSalvo ? (
                <ContestacaoAnalise codigoReuniao={codigoSalvo} />
              ) : (
                <span className="d-inline-flex align-items-center gap-2 me-auto">
                  <button type="button" className="btn btn-danger" disabled>
                    <i className="fas fa-comment-dots me-2"></i>Não concordo / dar feedback
                  </button>
                  <small className="text-muted">
                    <i className="fas fa-circle-info me-1"></i>
                    Para liberar este botão, clique em <strong>Salvar Análise</strong> primeiro.
                  </small>
                </span>
              )}
              <button 
                className="btn btn-secondary" 
                onClick={() => setShowModalAnalise(false)}
              >
                <i className="fas fa-times me-2"></i>
                Fechar
              </button>
       
              {!modoVisualizacao && (
                <>
                  <button
                    className="btn btn-success"
                    onClick={salvarAnalise}
                    disabled={salvando || !!codigoSalvo || bloquearSalvar}
                    title={bloquearSalvar ? 'Preencha empresa e produto para salvar' : ''}
                  >
                    {salvando ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Salvando...
                      </>
                    ) : codigoSalvo ? (
                      <>
                        <i className="fas fa-check me-2"></i>
                        Salvo ({codigoSalvo})
                      </>
                    ) : (
                      <>
                        <i className="fas fa-save me-2"></i>
                        Salvar Análise
                      </>
                    )}
                  </button>
                  <button
                    className="btn btn-info"
                    onClick={criarTarefasCalendario}
                    disabled={criandoTarefas || !analiseAtual || (!codigoSalvo && bloquearSalvar)}
                  >
                    {criandoTarefas ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Criando...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-calendar-plus me-2"></i>
                        Criar Tarefas no Calendário
                      </>
                    )}
                  </button>
                </>
              )}

              {!modoVisualizacao && bloquearSalvar && !codigoSalvo && (
                <div className="w-100 mt-3">
                  <div className="alert alert-warning py-2 px-3 mb-0 d-flex align-items-center gap-2" style={{fontSize: '0.85rem'}}>
                    <i className="fas fa-lock"></i>
                    <span>
                      Para salvar, preencha:
                      {[
                        empresaNaoIdentificada && 'a empresa (cliente)',
                        faltaDominio && 'o nº de domínio',
                        faltaProduto && (tipoReuniao === 'gestao' ? 'o setor' : 'o produto/serviço'),
                      ].filter(Boolean).map((txt, i, arr) => (
                        <React.Fragment key={i}>
                          {i > 0 && (i === arr.length - 1 ? ' e ' : ', ')}
                          <strong>{txt}</strong>
                        </React.Fragment>
                      ))}.
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderModalAviso = () => {
    if (!showModalAviso || avisosPendentes.length === 0) return null;

    return (
      <div
        className="modal fade show d-block"
        style={{ backgroundColor: 'rgba(0,0,0,0.55)', zIndex: 1060 }}
        onClick={() => setShowModalAviso(false)}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
          style={{ maxWidth: '560px' }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content">
            <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
              <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                <i className="fas fa-user-slash me-2" style={{ color: '#d610b5' }}></i>
                Operador não cadastrado no Memor.IA
              </h5>
              <button className="btn-close" onClick={() => setShowModalAviso(false)}></button>
            </div>

            <div className="modal-body">
              <p className="text-muted mb-3">
                {avisosPendentes.length === 1
                  ? 'A pessoa abaixo tem tarefas nesta reunião, mas ainda não está cadastrada no Memor.IA — as tarefas não foram criadas na agenda dela. Copie a mensagem e envie no chat para avisá-la.'
                  : 'As pessoas abaixo têm tarefas nesta reunião, mas ainda não estão cadastradas no Memor.IA — as tarefas não foram criadas na agenda delas. Copie a mensagem e envie no chat para avisá-las.'}
              </p>

              {avisosPendentes.map((pessoa, idx) => (
                <div key={idx} className="card mb-3" style={{ borderLeft: '4px solid #d610b5' }}>
                  <div className="card-body py-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <strong>
                        <i className="fas fa-user me-2 text-muted"></i>
                        {pessoa.nome}
                      </strong>
                      <span className="badge bg-secondary">
                        {pessoa.tarefas.length} tarefa(s)
                      </span>
                    </div>

                    {pessoa.tarefas.length > 0 && (
                      <ul className="mb-3 ps-3" style={{ fontSize: '0.88rem' }}>
                        {pessoa.tarefas.map((t, j) => (
                          <li key={j} className="mb-1">
                            {t.tarefa}
                            {t.prazo && <span className="text-muted"> — prazo: {t.prazo}</span>}
                          </li>
                        ))}
                      </ul>
                    )}

                    <div className="text-end">
                      <button
                        className={`btn btn-sm ${copiadoIdx === idx ? 'btn-success' : 'btn-primary'}`}
                        onClick={() => copiarAvisoTarefas(idx)}
                      >
                        {copiadoIdx === idx ? (
                          <><i className="fas fa-check me-1"></i>Mensagem copiada!</>
                        ) : (
                          <><i className="fas fa-copy me-1"></i>Copiar mensagem para o chat</>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowModalAviso(false)}>
                <i className="fas fa-times me-1"></i>
                Agora não
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="das-page">
      <div className="container-fluid mt-4">
        {/* Header com Gradiente - IGUAL AO REUNIOES.JS */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-start">
                  {/* Lado Esquerdo */}
                  <div className="flex-grow-1">
                    <div className="mb-4">
                      <span className="badge bg-light text-dark me-2" style={{fontSize: '20px', fontWeight: '500'}}>
                        Reuniões Gravadas - Google Meet
                      </span>
                      <span className="badge bg-warning text-dark" style={{fontSize: '15px', fontWeight: '500'}}>
                        <i className="fas fa-video me-1"></i>
                        Google Drive
                      </span>
                    </div>

                    <div className="d-flex align-items-center mb-2">
                      <i className="fas fa-brain header-icon me-2"></i>
                      <h2 className="titulo-pagina m-0">Análise Inteligente com a Memor.IA</h2>
                    </div>
                    <p className="mb-1 opacity-75">
                      <i className="fas fa-robot me-2"></i>
                      Transcrição + Análise Automática de Reuniões
                    </p>

                    {nomeColaborador && (
                      <small className="opacity-75 d-block">
                        <i className="fas fa-user me-1"></i>
                        Visualizando reuniões de: <strong>{nomeColaborador}</strong>
                      </small>
                    )}
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mensagens agora são exibidas como toast (react-toastify) */}

        {/* Aviso: usuário ainda não fez a autenticação com o Google */}
        {calendarConectado === false && (
          <div className="row mb-4">
            <div className="col-12">
              <div className="card border-0 shadow-sm" style={{ borderLeft: '4px solid #f4b400' }}>
                <div className="card-body d-flex align-items-center gap-3 flex-wrap py-3">
                  <div style={{
                    width: 48, height: 48, borderRadius: '50%', flexShrink: 0,
                    background: 'linear-gradient(135deg, #4285f4 0%, #34a853 100%)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    <i className="fab fa-google" style={{ color: '#fff', fontSize: '1.3rem' }}></i>
                  </div>
                  <div className="flex-grow-1" style={{ minWidth: 260 }}>
                    <h6 className="fw-bold mb-1">
                      Suas reuniões ainda não estão autorizadas para leitura
                    </h6>
                    <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
                      Faça a autorização das suas <strong>reuniões</strong> e da sua <strong>agenda</strong> com
                      sua conta Google — é uma única autorização e libera a leitura das reuniões
                      e a criação de tarefas na agenda.
                    </p>
                  </div>
                  <button
                    className="btn"
                    onClick={() => navigate('/configuracao-calendario')}
                    style={{
                      background: 'linear-gradient(135deg, #4285f4 0%, #34a853 100%)',
                      border: 'none', color: '#fff', borderRadius: 10,
                      padding: '0.55rem 1.4rem', fontWeight: 600, whiteSpace: 'nowrap',
                    }}
                  >
                    <i className="fab fa-google me-2"></i>
                    Autorizar Reuniões + Agenda
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Filtros */}
        <div className="row g-4 mb-4">
          {!apenasPropio && (
            <div className="col-md-6">
              <div className="card border-0 shadow-sm h-100">
                <div className="card-header bg-white">
                  <h5 className="card-title mb-0">
                    <i className="fas fa-user me-2 text-primary"></i>
                    Colaborador
                  </h5>
                </div>
                <div className="card-body d-flex flex-column">
                  <select
                    className="form-select flex-fill"
                    value={colaboradorSelecionado}
                    onChange={(e) => setColaboradorSelecionado(e.target.value)}
                  >
                    <option value="">Selecione...</option>
                    {colaboradores.map(colab => (
                      <option key={colab.id} value={colab.id}>
                        {colab.nome}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          )}

          <div className={apenasPropio ? 'col-12' : 'col-md-6'}>
            <div className="card border-0 shadow-sm h-100">
              <div className="card-header bg-white">
                <h5 className="card-title mb-0">
                  <i className="fas fa-calendar me-2 text-success"></i>
                  Período
                </h5>
              </div>
              <div className="card-body d-flex flex-column">
                {/* Filtros rápidos */}
                <div className="d-flex gap-2 flex-wrap mb-3">
                  {[['Último mês', 1], ['2 meses', 2], ['3 meses', 3]].map(([rotulo, m]) => {
                    const ativo = !dataFim && dataFiltro === mesesAtras(m);
                    // mesmo estilo dos filtros da lista (pílula, selecionado preenchido)
                    const cor = '#00205b';
                    return (
                      <button
                        key={m}
                        type="button"
                        aria-pressed={ativo}
                        className="btn d-inline-flex align-items-center"
                        onClick={() => aplicarPeriodoRapido(m)}
                        style={{
                          fontSize: '0.9rem',
                          fontWeight: 600,
                          padding: '6px 14px',
                          borderRadius: 999,
                          border: `1.5px solid ${cor}`,
                          background: ativo ? cor : '#ffffff',
                          color: ativo ? '#ffffff' : cor,
                          boxShadow: ativo ? '0 2px 6px rgba(0,0,0,0.15)' : 'none',
                        }}
                      >
                        <i className={`fas ${ativo ? 'fa-calendar-check' : 'fa-calendar'} me-2`}></i>
                        {rotulo}
                      </button>
                    );
                  })}
                </div>
                {/* Período específico */}
                <div className="d-flex gap-3 flex-wrap align-items-end">
                  {/* mesmo estilo dos botões de período: contorno navy, cantos arredondados, negrito */}
                  {[
                    ['DE', dataFiltro, setDataFiltro, 'datafiltro-de'],
                    ['ATÉ', dataFim, setDataFim, 'datafiltro-ate'],
                  ].map(([rotulo, valor, setValor, id]) => (
                    <div key={id}>
                      <label htmlFor={id} className="d-block mb-1"
                        style={{ fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.04em', color: '#00205b' }}>
                        <i className="fas fa-calendar-day me-1"></i>{rotulo}
                      </label>
                      <input
                        id={id}
                        type="date"
                        className="form-control"
                        value={valor}
                        onChange={(e) => setValor(e.target.value)}
                        style={{
                          fontSize: '0.9rem',
                          fontWeight: 600,
                          color: valor ? '#00205b' : '#6c757d',
                          padding: '6px 14px',
                          borderRadius: 999,
                          border: `1.5px solid ${valor ? '#00205b' : '#adb5bd'}`,
                          background: '#ffffff',
                          minWidth: 160,
                        }}
                      />
                    </div>
                  ))}
                  {dataFim && (
                    <button
                      type="button"
                      className="btn d-inline-flex align-items-center"
                      onClick={() => setDataFim('')}
                      title="Limpar data final"
                      style={{
                        fontSize: '0.85rem', fontWeight: 600, padding: '6px 12px', borderRadius: 999,
                        border: '1.5px solid #adb5bd', background: '#ffffff', color: '#6c757d',
                      }}
                    >
                      <i className="fas fa-times me-1"></i>Limpar
                    </button>
                  )}
                </div>
                <small className="text-muted mt-2">
                  <i className="fas fa-folder me-1"></i>
                  {reunioesNoPeriodo.length} reunião(ões) {dataFim
                    ? `entre ${formatarDataBR(dataFiltro)} e ${formatarDataBR(dataFim)}`
                    : `a partir de ${formatarDataBR(dataFiltro)}`}
                </small>
              </div>
            </div>
          </div>
        </div>

        {/* Filtro Lidas / Não Lidas */}
        {!loading && reunioes.length > 0 && (
          <div className="row mb-3">
            <div className="col-12">
              <div className="d-flex align-items-center gap-2 flex-wrap bg-white border rounded-3 shadow-sm px-3 py-2">
                <span className="fw-semibold me-1" style={{ color: '#495057', fontSize: '0.85rem' }}>
                  <i className="fas fa-filter me-1"></i>Filtrar:
                </span>
                {[
                  // cor = estado: navy (todas), âmbar (pendente), verde (feito), cinza (fora da análise)
                  { key: 'todas',     label: 'Todas',          icon: 'fa-list',         cor: '#00205b' },
                  { key: 'nao_lidas', label: 'Não Analisadas', icon: 'fa-hourglass-half', cor: '#b54708' },
                  { key: 'lidas',     label: 'Analisadas',     icon: 'fa-check-circle', cor: '#067647' },
                  { key: 'ignoradas', label: 'Internas',       icon: 'fa-eye-slash',    cor: '#6c757d' },
                ].map(op => {
                  const ativo = filtroLidas === op.key;
                  const total = op.key === 'todas' ? reunioesNoPeriodo.filter(r => !r.ignorada).length
                    : op.key === 'lidas' ? reunioesNoPeriodo.filter(r => r.lida && !r.ignorada).length
                    : op.key === 'ignoradas' ? reunioesNoPeriodo.filter(r => r.ignorada).length
                    : reunioesNoPeriodo.filter(r => !r.lida && !r.ignorada).length;
                  return (
                    <button
                      key={op.key}
                      type="button"
                      aria-pressed={ativo}
                      className="btn d-inline-flex align-items-center"
                      onClick={() => setFiltroLidas(op.key)}
                      style={{
                        fontSize: '0.9rem',
                        fontWeight: 600,
                        padding: '6px 14px',
                        borderRadius: 999,
                        border: `1.5px solid ${op.cor}`,
                        background: ativo ? op.cor : '#ffffff',
                        color: ativo ? '#ffffff' : op.cor,
                        boxShadow: ativo ? '0 2px 6px rgba(0,0,0,0.15)' : 'none',
                      }}
                    >
                      <i className={`fas ${op.icon} me-2`}></i>
                      {op.label}
                      <span
                        className="ms-2"
                        style={{
                          minWidth: 26,
                          padding: '1px 8px',
                          borderRadius: 999,
                          fontSize: '0.8rem',
                          fontWeight: 700,
                          fontVariantNumeric: 'tabular-nums',
                          background: ativo ? '#ffffff' : `${op.cor}1a`,
                          color: op.cor,
                        }}
                      >
                        {total}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {!loading && reunioes.length > 0 && renderBarraLote()}

        {/* Lista de Reuniões */}
        {loading ? (
          <div className="row">
            <div className="col-12">
              <div className="text-center mt-5 mb-5">
                <div className="spinner-border text-primary" style={{width: '3rem', height: '3rem'}}>
                  <span className="visually-hidden">Carregando...</span>
                </div>
                <p className="mt-3 text-muted">
                  <i className="fas fa-folder-open me-2"></i>
                  Carregando reuniões do Google Drive...
                </p>
                <div className="progress mt-3" style={{height: '6px', maxWidth: '300px', margin: '0 auto'}}>
                  <div className="progress-bar progress-bar-striped progress-bar-animated" style={{width: '100%'}}></div>
                </div>
              </div>
            </div>
          </div>
        ) : reunioesNoPeriodo.length === 0 ? (
          <div className="row mb-4">
            <div className="col-12">
              <div className="card border-0 shadow-sm">
                <div className="card-header bg-white">
                  <h5 className="card-title mb-0">
                    <i className="fas fa-video me-2 text-muted"></i>
                    Reuniões do Dia
                  </h5>
                </div>
                <div className="card-body text-center py-5">
                  <i className="fas fa-folder-open fa-3x text-muted mb-3"></i>
                  <h5 className="text-muted">Nenhuma reunião encontrada</h5>
                  <p className="text-muted mb-0">
                    Não há reuniões a partir de {formatarDataBR(dataFiltro)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
         <div className="row g-4 mb-4">
  {reunioesNoPeriodo
    .filter(passaFiltroAba)
    .map((reuniao, index) => (
    <div key={index} className="col-12">
      <div className={`card border-0 shadow-sm ${reuniao.lida ? 'border-start border-success border-3' : ''}`}>
    <div className="card-header bg-white">
  <div className="d-flex justify-content-between align-items-center flex-wrap">
    <div className="d-flex align-items-start gap-2">
      {podeAnalisarEmLote(reuniao) && (
        <input
          type="checkbox"
          className="form-check-input mt-2"
          style={{ width: 20, height: 20, cursor: 'pointer', borderColor: '#a30c8a' }}
          checked={!!selecionadas[chaveReuniao(reuniao)]}
          onChange={() => alternarSelecao(reuniao)}
          title="Selecionar para análise em lote"
          aria-label={`Selecionar ${reuniao.titulo} para análise em lote`}
        />
      )}
    <div>
      <h5 className="card-title mb-1">
        <i className="fas fa-building me-2 text-primary"></i>
        <span className="badge bg-primary me-2">{reuniao.cliente}</span>
        <span className="text-dark">{reuniao.titulo}</span>
        {reuniao.lida && (
          <span className="badge bg-success ms-2" style={{fontSize: '0.7rem'}}>
            <i className="fas fa-check-circle me-1"></i>
            {reuniao.analisado_por ? `Analisada por ${reuniao.analisado_por}` : 'Analisada'}
          </span>
        )}
        {reuniao.ignorada && (
          <span className="badge bg-secondary ms-2" style={{fontSize: '0.7rem'}}>
            <i className="fas fa-eye-slash me-1"></i>Interna
          </span>
        )}
        {reuniao.responsavel_nome && (
          <span
            className="badge ms-2"
            style={{ background: '#e9ecef', color: '#495057', fontSize: '0.7rem' }}
            title="Dono da gravação/transcrição no Google Drive — só ele analisa"
          >
            <i className="fas fa-user-check me-1"></i>Responsável: {reuniao.responsavel_nome}
          </span>
        )}
      </h5>
      <small className="text-muted">
        <i className="fas fa-clock me-1"></i>
        {formatarData(reuniao.data)} às {reuniao.hora}
        {reuniao.duracao_min && (
          <span className="badge ms-2" style={{ background: '#e9ecef', color: '#495057', fontSize: '0.72rem' }}>
            <i className="fas fa-hourglass-half me-1"></i>
            {reuniao.duracao_min >= 60
              ? `${Math.floor(reuniao.duracao_min / 60)}h${String(reuniao.duracao_min % 60).padStart(2, '0')}`
              : `${reuniao.duracao_min} min`}
          </span>
        )}
      </small>
    </div>
    
    </div>
    {/* ← BOTÕES DEVEM ESTAR AQUI */}
    <div className="d-flex gap-2 align-items-center">
      {reuniao.ignorada ? (
        <button
          className="btn btn-outline-primary"
          onClick={() => toggleIgnorarReuniao(reuniao)}
          disabled={validandoInterna === `${reuniao.titulo}|${reuniao.data}`}
        >
          <i className="fas fa-eye me-2"></i>
          Reexibir reunião
        </button>
      ) : (
        <>
          <button
            className="btn btn-outline-secondary"
            onClick={() => toggleIgnorarReuniao(reuniao)}
            disabled={validandoInterna === `${reuniao.titulo}|${reuniao.data}`}
            title="Marcar como reunião interna — a Memor.IA valida se todos os participantes são internos"
          >
            {validandoInterna === `${reuniao.titulo}|${reuniao.data}` ? (
              <>
                <span className="spinner-border spinner-border-sm me-2"></span>
                Verificando...
              </>
            ) : (
              <>
                <i className="fas fa-eye-slash me-2"></i>
                Reunião interna
              </>
            )}
          </button>
          {reuniao.lida && reuniao.codigo_reuniao ? (
            <>
              <button
                className="btn btn-outline-success"
                onClick={() => abrirAnaliseSalva(reuniao.codigo_reuniao)}
                disabled={carregandoAnaliseSalva === reuniao.codigo_reuniao}
                title="Ver a análise completa desta reunião"
              >
                {carregandoAnaliseSalva === reuniao.codigo_reuniao ? (
                  <><span className="spinner-border spinner-border-sm me-2"></span>Abrindo...</>
                ) : (
                  <><i className="fas fa-eye me-2"></i>Ver análise</>
                )}
              </button>
              {usuarioAdm && (
              <button
                className="btn btn-outline-secondary"
                onClick={() => { setReanalisando(true); abrirModalTipo(reuniao); }}
                disabled={analisando || !reuniao.arquivos?.anotacoes}
                title="Rodar a análise novamente (gera uma nova análise para testes)"
              >
                {(analisando && reuniaoAnalisandoKey === `${reuniao.titulo}|${reuniao.data}`) ? (
                  <><span className="spinner-border spinner-border-sm me-2"></span>Analisando...</>
                ) : (
                  <><i className="fas fa-rotate-right me-2"></i>Reanalisar</>
                )}
              </button>
              )}
            </>
          ) : (reuniao.sou_responsavel === false && !usuarioAdm) ? (
            <div className="d-flex flex-column align-items-end">
              <button className="btn btn-outline-secondary" disabled>
                <i className="fas fa-lock me-2"></i>
                Analisar com Memor.IA
              </button>
              <small className="text-muted mt-1">
                Reunião de {reuniao.responsavel_nome || 'outro participante'} — só o responsável analisa
              </small>
            </div>
          ) : (
            <>
            {usuarioAdm && reuniao.sou_responsavel === false && (
              <span
                className="badge"
                style={{ background: '#fff3cd', color: '#856404', fontSize: '0.7rem' }}
                title="Você é adm e pode analisar, mas a reunião é de outro participante"
              >
                Responsável: {reuniao.responsavel_nome || reuniao.responsavel_email}
              </span>
            )}
            {(() => {
              const it = lote[chaveReuniao(reuniao)];
              if (!it) return null;
              if (it.status === 'na_fila' || it.status === 'analisando') {
                return (
                  <span className="badge" style={{ background: '#f3e8fb', color: '#a30c8a', fontSize: '0.8rem', padding: '8px 12px' }}>
                    {it.status === 'analisando'
                      ? <><span className="spinner-border spinner-border-sm me-1"></span>Analisando no lote…</>
                      : <><i className="fas fa-clock me-1"></i>Na fila do lote</>}
                  </span>
                );
              }
              if (it.status === 'pronta') {
                return (
                  <button className="btn btn-warning fw-semibold" onClick={() => revisarItemLote(chaveReuniao(reuniao))}>
                    <i className="fas fa-pen-to-square me-2"></i>Revisar e salvar
                  </button>
                );
              }
              if (it.status === 'erro') {
                return (
                  <small className="text-danger" title={it.erro}>
                    <i className="fas fa-triangle-exclamation me-1"></i>Erro no lote
                    <button type="button" className="btn btn-link btn-sm p-0 ms-1" onClick={() => descartarItemLote(chaveReuniao(reuniao))}>ok</button>
                  </small>
                );
              }
              return null;
            })()}
            {!['na_fila', 'analisando', 'pronta'].includes(lote[chaveReuniao(reuniao)]?.status) && (
            <button
              className="btn btn-primary"
              onClick={() => { setReanalisando(false); abrirModalTipo(reuniao); }}
              disabled={analisando || !reuniao.arquivos?.anotacoes}
              style={{
                background: 'linear-gradient(135deg, #d610b5 0%, #a30c8a 100%)',
                border: 'none'
              }}
            >
              {(analisando && reuniaoAnalisandoKey === `${reuniao.titulo}|${reuniao.data}`) ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Analisando...
                </>
              ) : (
                <>
                  <i className="fas fa-brain me-2"></i>
                  Analisar com Memor.IA
                </>
              )}
            </button>
            )}
            </>
          )}
        </>
      )}
    </div>
  </div>
</div>

   <div className="card-body py-2">
  <div className="d-flex flex-wrap gap-3 align-items-center">

    {reuniao.arquivos && reuniao.arquivos.anotacoes && (
      <div className="d-flex align-items-center gap-2 border rounded px-3 py-2" style={{ background: '#f8f9fa' }}>
        <i className="fas fa-file-alt text-primary"></i>
        <div>
          <small className="d-block fw-semibold">Anotações/Transcrição</small>
          <small className="text-muted">{formatarTamanho(reuniao.arquivos.anotacoes.tamanho)}</small>
        </div>
        <a href={reuniao.arquivos.anotacoes.url} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-primary ms-1">
          <i className="fas fa-external-link-alt me-1"></i>Abrir
        </a>
      </div>
    )}

    {reuniao.arquivos && reuniao.arquivos.chat && (
      <div className="d-flex align-items-center gap-2 border rounded px-3 py-2" style={{ background: '#f8f9fa' }}>
        <i className="fas fa-comments text-success"></i>
        <div>
          <small className="d-block fw-semibold">Chat da Reunião</small>
          <small className="text-muted">{formatarTamanho(reuniao.arquivos.chat.tamanho)}</small>
        </div>
        <a href={reuniao.arquivos.chat.url} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-success ms-1">
          <i className="fas fa-external-link-alt me-1"></i>Abrir
        </a>
      </div>
    )}

    {reuniao.arquivos && reuniao.arquivos.recording && (
      <div className="d-flex align-items-center gap-2 border rounded px-3 py-2" style={{ background: '#f8f9fa' }}>
        <i className="fas fa-video text-danger"></i>
        <div>
          <small className="d-block fw-semibold">Gravação em Vídeo</small>
          <small className="text-muted">{formatarTamanho(reuniao.arquivos.recording.tamanho)}</small>
        </div>
        <a href={reuniao.arquivos.recording.url} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-outline-danger ms-1">
          <i className="fas fa-play me-1"></i>Assistir
        </a>
      </div>
    )}

  </div>
</div>
      </div>
    </div>
  ))}
</div>
      )}
      {renderModalTipo()}
      {renderModalLote()}
      {renderModalAnalise()}
      {renderModalAviso()}

      {/* ── Modal: convite para a Documentação ── */}
      {showModalDoc && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: 'rgba(0,0,0,0.55)', zIndex: 1300 }}
          onClick={() => setShowModalDoc(false)}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            style={{ maxWidth: 520 }}
            onClick={e => e.stopPropagation()}
          >
            <div className="modal-content" style={{ borderRadius: 16, overflow: 'hidden' }}>
              <div className="modal-body text-center px-4 pt-4 pb-3">
                <MemoraAnimacao tamanho={180} style={{ margin: '0 auto' }} />
                <h5 className="fw-bold mb-2" style={{ color: '#212529' }}>
                  Primeira vez por aqui? 
                </h5>
                <p className="text-muted mb-1" style={{ fontSize: '0.95rem', lineHeight: '1.65' }}>
                  Sou a <strong>Memor.IA</strong>! Antes de analisar suas reuniões, dá uma passada na página de{' '}
                  <strong>Documentação</strong> — lá eu explico como avalio cada tipo de reunião, o que é uma boa
                  entrega e tudo que você ganha comigo. Leva 3 minutinhos e melhora muito a sua experiência. 
                </p>
              </div>
              <div className="modal-footer justify-content-center border-0 pb-4 pt-0 flex-column gap-2">
                <button
                  className="btn fw-semibold"
                  onClick={() => {
                    marcarDocVisto();
                    setShowModalDoc(false);
                    navigate('/memora-documentacao');
                  }}
                  style={{
                    background: 'linear-gradient(135deg, #d610b5 0%, #a30c8a 100%)',
                    border: 'none', color: '#fff', borderRadius: 12, padding: '0.55rem 1.8rem',
                    boxShadow: '0 2px 8px rgba(214,16,181,0.35)',
                  }}
                >
                  <i className="fas fa-book-open me-2"></i>Ver a Documentação
                </button>
                <div className="d-flex gap-3">
                  <button className="btn btn-link btn-sm text-muted text-decoration-none" onClick={() => setShowModalDoc(false)}>
                    Agora não
                  </button>
                  <button
                    className="btn btn-link btn-sm text-muted text-decoration-none"
                    onClick={() => {
                      marcarDocVisto();
                      setShowModalDoc(false);
                    }}
                  >
                    Não mostrar de novo
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.05);
            opacity: 0.9;
          }
        }
        .modal.show {
          display: block;
        }
      `}</style>
      </div>
    </div>
  );
};

export default ListaReunioes;